/* prettier-ignore */
 export const CONMAN_DATA = {
  "cities": [
    {
      "is_live": true,
      "regex_key": "beed",
      "name": "Beed",
      "key": "city_beed_v2",
      "seo_city_key": "India|Beed",
      "customer_city": "city_beed_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Beed",
        "beed",
        "Beed"
      ],
      "subcities": [
        "beed"
      ],
      "city_address_hint": "F8P8+CV5, Kalwakurthy - Nagarkurnool Rd, Nagarkurnool, Telangana 509209, India",
      "url_name": "beed",
      "country_name": "India",
      "postal_code": "431122",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 16.485938,
        "long": 78.317196,
        "details": "F8P8+CV5, Kalwakurthy - Nagarkurnool Rd, Nagarkurnool, Telangana 509209, India",
        "google_place_id": "ChIJXTbSmJ9syjsR_6h2L3ESDkA"
      },
      "bounds": [
        18.708024,
        75.054337,
        19.413671,
        76.264049
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "chennai",
      "name": "Chennai",
      "key": "city_chennai_v2",
      "seo_city_key": "india|chennai",
      "customer_city": "city_chennai_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "chennai",
        "madras"
      ],
      "subcities": [
        "Chennai",
        "chennai",
        "Tiruvallur",
        "Kanchipuram",
        "Chengalpattu"
      ],
      "city_address_hint": "4744+HMQ, N Town Internal Rd, Binny Garden, Jamalia, Chennai, Tamil Nadu 600012, India",
      "url_name": "chennai",
      "country_name": "India",
      "postal_code": "600032",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 13.106206,
        "long": 80.257134,
        "details": "4744+HMQ, N Town Internal Rd, Binny Garden, Jamalia, Chennai, Tamil Nadu 600012, India",
        "google_place_id": "ChIJE9GJOABlUjoRFfKH_nfn5NA"
      },
      "bounds": [
        12.810792,
        80.030689,
        13.1958275,
        80.3217316
      ],
      "offices": [
        {
          "name": "Chennai",
          "is_live": true,
          "address": "C 32 A Cipet Road, Thiru Vi Ka Industrial Estate, SIDCO Industrial Estate, Guindy, Chennai, Tamil Nadu - 600032",
          "subcities": [
            "Chennai"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 13.012201,
            "long": 80.208527
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "kanpur",
      "name": "Kanpur",
      "key": "city_kanpur_v2",
      "seo_city_key": "india|kanpur",
      "customer_city": "city_kanpur_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "kanpur"
      ],
      "subcities": [
        "Kanpur",
        "kanpur"
      ],
      "city_address_hint": "Tilak Nagar, Kanpur",
      "url_name": "kanpur",
      "country_name": "India",
      "postal_code": "208001",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 26.490931,
        "long": 80.323517,
        "details": "Tilak Nagar, Kanpur",
        "google_place_id": "ChIJ54o0gF84nDkRhC4NbwJdAkc"
      },
      "bounds": [
        26.128649,
        80.10806,
        26.65499,
        80.951784
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "mumbai",
      "name": "Mumbai",
      "key": "city_mumbai_v2",
      "seo_city_key": "india|mumbai",
      "customer_city": "city_mumbai_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "mumbai",
        "bombay",
        "navi mumbai",
        "navi-mumbai",
        "navi_mumbai",
        "thane",
        "mira bhayandar",
        "dombivli",
        "kalyan",
        "nilje gaon",
        "nilje-gaon",
        "nilje_gaon",
        "nala sopara",
        "nalasopara",
        "virar",
        "vasai",
        "naigaon",
        "bhiwandi"
      ],
      "subcities": [
        "Mumbai",
        "Thane",
        "Navi-Mumbai",
        "mumbai",
        "thane",
        "navi-mumbai",
        "Mira Bhayandar",
        "Dombivli",
        "Kalyan",
        "Nilje Gaon",
        "Nala Sopara",
        "Nalasopara",
        "Virar",
        "Vasai",
        "Naigaon",
        "bhiwandi"
      ],
      "city_address_hint": "1201, Cliff Ave, Hiranandani Gardens, Powai, Mumbai, Maharashtra 400076, India",
      "url_name": "mumbai",
      "country_name": "India",
      "postal_code": "400071",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 19.115382,
        "long": 72.912044,
        "details": "1201, Cliff Ave, Hiranandani Gardens, Powai, Mumbai, Maharashtra 400076, India",
        "google_place_id": "ChIJRVC-7OjH5zsRehLSFfVjMas"
      },
      "bounds": [
        18.879368,
        72.667687,
        19.64772,
        73.379726
      ],
      "offices": [
        {
          "name": "Sion",
          "is_live": false,
          "address": "Urban Company Limited, Unit Nos. 1101 and 1102, 11th Floor in C Wing “Godrej Coliseum” C.T.S. No.638(part) of Kurla Village, Lokmanya Pan Bazaar, behind Everard Nagar, Sion (East), Mumbai – 400 022",
          "subcities": [
            "Mumbai",
            "Navi-Mumbai"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 19.050042,
            "long": 72.8765241
          }
        },
        {
          "name": "Mumbai",
          "is_live": true,
          "address": "Urban Company Limited, 2nd Floor, Mehra Estate, CTS No. 69, 69/1 to 52, L.B.S Marg, Vikhroli (West), Mumbai, Maharashtra 400079",
          "subcities": [
            "Mumbai"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 28.50816,
            "long": 77.08999
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "hyderabad",
      "name": "Hyderabad",
      "key": "city_hyderabad_v2",
      "seo_city_key": "india|hyderabad",
      "customer_city": "city_hyderabad_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "hyderabad",
        "secunderabad"
      ],
      "subcities": [
        "Hyderabad",
        "Secunderabad",
        "hyderabad",
        "secunderabad"
      ],
      "city_address_hint": "A-22, Lakshmi Narsimha Nagar Rd, Sri Nagar Colony, Krishna Nagar, Yousufguda, Hyderabad, Telangana 500045, India",
      "url_name": "hyderabad",
      "country_name": "India",
      "postal_code": "500081",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 17.433453,
        "long": 78.428083,
        "details": "A-22, Lakshmi Narsimha Nagar Rd, Sri Nagar Colony, Krishna Nagar, Yousufguda, Hyderabad, Telangana 500045, India",
        "google_place_id": "ChIJrcEaSyiRyzsRmu06d_O9VEs"
      },
      "bounds": [
        17.169002,
        77.66716,
        17.789228,
        78.732834
      ],
      "offices": [
        {
          "name": "Hyderabad",
          "is_live": true,
          "address": "6th Floor, Perati KKR Commercial Complex, Survey Nos. 698/P, 670, and 671, Kukatpally (V), Malkajgiri, Hyderabad, Telangana-500072",
          "subcities": [
            "Hyderabad",
            "Secunderabad"
          ],
          "office_type": [
            "corporate",
            "training",
            "business",
            "support"
          ],
          "location_mapping": {
            "lat": 17.4753599,
            "long": 78.4233924
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ballia",
      "name": "Ballia",
      "key": "city_ballia_v2",
      "seo_city_key": "India|Ballia",
      "customer_city": "city_ballia_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ballia",
        "ballia",
        "Ballia"
      ],
      "subcities": [
        "ballia"
      ],
      "city_address_hint": "1, Ballia, Uttar Pradesh 243402, India",
      "url_name": "ballia",
      "country_name": "India",
      "postal_code": "243402",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 28.2006882,
        "long": 79.3651914,
        "details": "1, Ballia, Uttar Pradesh 243402, India",
        "google_place_id": "ChIJjyY9hJpVdTkRTJRLokzn2EA"
      },
      "bounds": [
        25.665657,
        83.734009,
        26.044935,
        84.543112
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "bilaspur",
      "name": "Bilaspur",
      "key": "city_bilaspur_v2",
      "seo_city_key": "India|Bilaspur",
      "customer_city": "city_bilaspur_v2",
      "state": "Chhattisgarh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Bilaspur",
        "bilaspur",
        "Bilaspur"
      ],
      "subcities": [
        "bilaspur"
      ],
      "city_address_hint": "00, Bilaspur, Masanganj, Chhattisgarh 495001, India",
      "url_name": "bilaspur",
      "country_name": "India",
      "postal_code": "495001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 22.0796545,
        "long": 82.1409152,
        "details": "00, Bilaspur, Masanganj, Chhattisgarh 495001, India",
        "google_place_id": "ChIJp7aaexELKDoRr3ysnp3488Y"
      },
      "bounds": [
        21.868883,
        81.842225,
        22.401248,
        82.461619
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "chandigarh",
      "name": "Chandigarh Tricity",
      "key": "city_chandigarh_v2",
      "seo_city_key": "india|chandigarh",
      "customer_city": "city_chandigarh_v2",
      "state": "Punjab and Haryana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "chandigarh",
        "mohali",
        "zirakpur",
        "panchkula",
        "Sahibzada Ajit Singh",
        "sahibzada ajit singh",
        "Sahibzada Ajit Singh Nagar"
      ],
      "subcities": [
        "Chandigarh",
        "Mohali",
        "Zirakpur",
        "Panchkula",
        "Sahibzada Ajit Singh",
        "Sahibzada Ajit Singh Nagar",
        "sahibzada ajit singh",
        "chandigarh",
        "mohali",
        "zirakpur",
        "panchkula",
        "Kharar",
        "Ambala"
      ],
      "city_address_hint": "Chandigarh, India",
      "url_name": "chandigarh",
      "country_name": "India",
      "postal_code": "160022",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 30.7333148,
        "long": 76.7794179,
        "details": "Chandigarh, India",
        "google_place_id": "ChIJa8lu5gvtDzkR_hlzUvln_6U"
      },
      "bounds": [
        30.587852,
        76.5827,
        30.815279,
        76.92602
      ],
      "offices": [
        {
          "name": "Chandigarh",
          "is_live": false,
          "address": "Plot No:- 66, Phase-2, Industrial Area, Chandigarh",
          "subcities": [
            "Chandigarh",
            "Mohali",
            "Zirakpur",
            "Panchkula",
            "Sahibzada Ajit Singh",
            "Sahibzada Ajit Singh Nagar"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 30.700561,
            "long": 76.788204
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "moradabad",
      "name": "Moradabad",
      "key": "city_moradabad_v2",
      "seo_city_key": "India|Moradabad",
      "customer_city": "city_moradabad_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Moradabad",
        "moradabad",
        "Moradabad"
      ],
      "subcities": [
        "moradabad"
      ],
      "city_address_hint": "MIG-67 RAM GANGA VIHAR EX. PHASE-2 NEAR DAP MANDIR MARADABAD, Pat Pat Sarai, Moradabad, Uttar Pradesh 244001, India",
      "url_name": "moradabad",
      "country_name": "India",
      "postal_code": "244001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 28.8386481,
        "long": 78.7733286,
        "details": "MIG-67 RAM GANGA VIHAR EX. PHASE-2 NEAR DAP MANDIR MARADABAD, Pat Pat Sarai, Moradabad, Uttar Pradesh 244001, India",
        "google_place_id": "ChIJyUZWL-r7CjkR25hT6eR8ybg"
      },
      "bounds": [
        28.406501,
        78.490963,
        29.198026,
        78.850165
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "buldhana",
      "name": "Buldhana",
      "key": "city_buldhana_v2",
      "seo_city_key": "India|Buldhana",
      "customer_city": "city_buldhana_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Buldhana",
        "buldhana",
        "Buldhana"
      ],
      "subcities": [
        "buldhana"
      ],
      "city_address_hint": "2, Chaitanyawadi, Buldana, Maharashtra 443001, India",
      "url_name": "buldhana",
      "country_name": "India",
      "postal_code": "443001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 20.5292147,
        "long": 76.1841701,
        "details": "2, Chaitanyawadi, Buldana, Maharashtra 443001, India",
        "google_place_id": "ChIJsZxtzfgd2jsRTbvwJJOgNl8"
      },
      "bounds": [
        19.900973,
        76.150435,
        21.055557,
        76.728033
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jalna",
      "name": "Jalna",
      "key": "city_jalna_v2",
      "seo_city_key": "India|Jalna",
      "customer_city": "city_jalna_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Jalna",
        "jalna",
        "Jalna"
      ],
      "subcities": [
        "jalna"
      ],
      "city_address_hint": "RVPJ+4GW, 13, Swaraj Rd, Kanchan Nagar, Bhagya Nagar, Jalna, Maharashtra 431213, India",
      "url_name": "jalna",
      "country_name": "India",
      "postal_code": "431213",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 19.835086,
        "long": 75.881351,
        "details": "RVPJ+4GW, 13, Swaraj Rd, Kanchan Nagar, Bhagya Nagar, Jalna, Maharashtra 431213, India",
        "google_place_id": "ChIJDWlj5kFX2jsRM5uDqxX3ZRY"
      },
      "bounds": [
        19.473025,
        75.704814,
        20.308489,
        76.090793
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "bhagalpur",
      "name": "Bhagalpur",
      "key": "city_bhagalpur_v2",
      "seo_city_key": "India|Bhagalpur",
      "customer_city": "city_bhagalpur_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Bhagalpur",
        "bhagalpur",
        "Bhagalpur"
      ],
      "subcities": [
        "bhagalpur"
      ],
      "city_address_hint": "6XPF+VRG, Tilkamanjhi, Bhagalpur, Habibpur, Bihar 812002, India",
      "url_name": "bhagalpur",
      "country_name": "India",
      "postal_code": "812002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.2371958,
        "long": 86.97457020000002,
        "details": "6XPF+VRG, Tilkamanjhi, Bhagalpur, Habibpur, Bihar 812002, India",
        "google_place_id": "ChIJlZyucCxL8DkRQoJJKGjH7Dc"
      },
      "bounds": [
        24.856237,
        86.763415,
        26.271019,
        87.777405
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Siwan",
      "name": "Siwan",
      "key": "city_siwan_v2",
      "seo_city_key": "India|Siwan",
      "customer_city": "city_siwan_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Siwan",
        "siwan",
        "Siwan"
      ],
      "subcities": [],
      "city_address_hint": "01, Naya Bazar, Sahjniya, Punak Buzurg, Siwan, Bihar 841239, India",
      "url_name": "Siwan",
      "country_name": "India",
      "postal_code": "841239",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 26.2243204,
        "long": 84.3599953,
        "details": "01, Naya Bazar, Sahjniya, Punak Buzurg, Siwan, Bihar 841239, India",
        "google_place_id": "ChIJg4njZgH8kjkRHyHVtxxsPGI"
      },
      "bounds": [
        26.086176,
        84.177404,
        26.572907,
        84.960064
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "bhojpur",
      "name": "Bhojpur",
      "key": "city_bhojpur_v2",
      "seo_city_key": "India|Bhojpur",
      "customer_city": "city_bhojpur_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Bhojpur",
        "bhojpur",
        "Bhojpur"
      ],
      "subcities": [
        "bhojpur"
      ],
      "city_address_hint": "FG8C+FV9, Aer, Bihar 802162, India",
      "url_name": "bhojpur",
      "country_name": "India",
      "postal_code": "802162",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.466155,
        "long": 84.5222189,
        "details": "FG8C+FV9, Aer, Bihar 802162, India",
        "google_place_id": "ChIJGQxF_11fjTkR_doBJrJRHTI"
      },
      "bounds": [
        25.156195,
        83.901065,
        25.661654,
        84.785452
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "meerut",
      "name": "Meerut",
      "key": "city_meerut_v2",
      "seo_city_key": "india|meerut",
      "customer_city": "city_meerut_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "meerut"
      ],
      "subcities": [
        "meerut",
        "Meerut"
      ],
      "city_address_hint": "Shohrab Gate",
      "url_name": "meerut",
      "country_name": "India",
      "postal_code": "250002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 28.9817545,
        "long": 77.6924025,
        "details": "Shohrab Gate",
        "google_place_id": "ChIJJWO2V_RkDDkRXr6mhzOo-kI"
      },
      "bounds": [
        28.823458,
        77.616262,
        29.611757,
        78.323246
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ambala",
      "name": "Ambala",
      "key": "city_ambala_v2",
      "seo_city_key": "India|Ambala",
      "customer_city": "city_ambala_v2",
      "state": "Haryana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ambala",
        "ambala",
        "Ambala"
      ],
      "subcities": [
        "ambala"
      ],
      "city_address_hint": "9QGJ+3VR, Police Line, Ambala, Haryana 134003, India",
      "url_name": "ambala",
      "country_name": "India",
      "postal_code": "134003",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 30.3752011,
        "long": 76.782122,
        "details": "9QGJ+3VR, Police Line, Ambala, Haryana 134003, India",
        "google_place_id": "ChIJEW8eQiq2DzkRFI0l9ymK0us"
      },
      "bounds": [
        29.512128,
        76.623091,
        30.493947,
        77.343064
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Sultanpur",
      "name": "Sultanpur",
      "key": "city_sultanpur_v2",
      "seo_city_key": "India|Sultanpur",
      "customer_city": "city_sultanpur_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "bamboo flat",
        "Sultanpur"
      ],
      "subcities": [],
      "city_address_hint": "736F+9FP, GN Rd, Civil Line, Sultanpur, Uttar Pradesh 228001",
      "url_name": "Sultanpur",
      "country_name": "India",
      "postal_code": "228001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.70817,
        "long": 92.7211179,
        "details": "736F+9FP, GN Rd, Civil Line, Sultanpur, Uttar Pradesh 228001",
        "google_place_id": "ChIJxVYP_Dq-iDARSdQXYYX4Og4"
      },
      "bounds": [
        25.706925,
        81.544613,
        26.60522,
        82.35824
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "bareilly",
      "name": "Bareilly",
      "key": "city_bareilly_v2",
      "seo_city_key": "India|Bareilly",
      "customer_city": "city_bareilly_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Bareilly",
        "bareilly",
        "Bareilly"
      ],
      "subcities": [
        "bareilly"
      ],
      "city_address_hint": "23, vikramaditya puri, sbi coloney, Bareilly, Haziyapur, Uttar Pradesh 243005, India",
      "url_name": "bareilly",
      "country_name": "India",
      "postal_code": "243005",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 28.3670355,
        "long": 79.4304381,
        "details": "23, vikramaditya puri, sbi coloney, Bareilly, Haziyapur, Uttar Pradesh 243005, India",
        "google_place_id": "ChIJjZkCTTMHoDkRf-ge80zUuQU"
      },
      "bounds": [
        28.162671,
        79.073868,
        28.624064,
        79.728127
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Chandauli",
      "name": "Chandauli",
      "key": "city_chandauli_v2",
      "seo_city_key": "India|Chandauli",
      "customer_city": "city_chandauli_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Chandauli"
      ],
      "subcities": [],
      "city_address_hint": "illiya Gt Road, Market, Ilia, Uttar Pradesh 232104",
      "url_name": "Chandauli",
      "country_name": "India",
      "postal_code": "232104",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.70817,
        "long": 92.7211179,
        "details": "illiya Gt Road, Market, Ilia, Uttar Pradesh 232104",
        "google_place_id": "ChIJxVYP_Dq-iDARSdQXYYX4Og4"
      },
      "bounds": [
        25.056476,
        83.116945,
        25.351047,
        83.455499
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Mau",
      "name": "Mau",
      "key": "city_mau_v2",
      "seo_city_key": "India|Mau",
      "customer_city": "city_mau_v2",
      "state": "Andaman and Nicobar Islands",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Mau"
      ],
      "subcities": [],
      "city_address_hint": "XG5W+J52, Mohalla Domanpura, Mirzahadi Pura, Mau, Uttar Pradesh 275101",
      "url_name": "Mau",
      "country_name": "India",
      "postal_code": "275101",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.70817,
        "long": 92.7211179,
        "details": "XG5W+J52, Mohalla Domanpura, Mirzahadi Pura, Mau, Uttar Pradesh 275101",
        "google_place_id": "ChIJxVYP_Dq-iDARSdQXYYX4Og4"
      },
      "bounds": [
        25.853848,
        83.129048,
        26.241578,
        83.725351
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "bhopal",
      "name": "Bhopal",
      "key": "city_bhopal_v2",
      "seo_city_key": "india|bhopal",
      "customer_city": "city_bhopal_v2",
      "state": "Madhya Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "bhopal"
      ],
      "subcities": [
        "bhopal",
        "Bhopal"
      ],
      "city_address_hint": "Jinsi Circle",
      "url_name": "bhopal",
      "country_name": "India",
      "postal_code": "462010",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 23.2494,
        "long": 77.4173,
        "details": "Jinsi Circle",
        "google_place_id": "ChIJvY_Wj49CfDkR-NRy1RZXFQI"
      },
      "bounds": [
        22.746909,
        76.723428,
        23.528781,
        77.7408
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Bharatpur",
      "name": "Bharatpur",
      "key": "city_bharatpur_v2",
      "seo_city_key": "India|Bharatpur",
      "customer_city": "city_bharatpur_v2",
      "state": "Rajasthan",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Bharatpur",
        "bharatpur",
        "Bharatpur"
      ],
      "subcities": [
        "bharatpur"
      ],
      "city_address_hint": "6G83+36C, Patpara Mohalla, Bharatpur, Rajasthan 321001, India",
      "url_name": "Bharatpur",
      "country_name": "India",
      "postal_code": "321001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 27.2151863,
        "long": 77.5029996,
        "details": "6G83+36C, Patpara Mohalla, Bharatpur, Rajasthan 321001, India",
        "google_place_id": "ChIJb3NahAqjczkRCM7ukzUQD1o"
      },
      "bounds": [
        26.906123,
        77.113037,
        27.342112,
        77.864869
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ujjain",
      "name": "Ujjain",
      "key": "city_ujjain_v2",
      "seo_city_key": "India|Ujjain",
      "customer_city": "city_ujjain_v2",
      "state": "Madhya Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ujjain",
        "ujjain",
        "Ujjain"
      ],
      "subcities": [
        "ujjain"
      ],
      "city_address_hint": "127, agrsen nahar, Magalcolony, Ujjain, Madhya Pradesh 456010, India",
      "url_name": "ujjain",
      "country_name": "India",
      "postal_code": "456010",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 23.1764665,
        "long": 75.7885163,
        "details": "127, agrsen nahar, Magalcolony, Ujjain, Madhya Pradesh 456010, India",
        "google_place_id": "ChIJI_8A3ml0YzkREtSZeN-rgn8"
      },
      "bounds": [
        22.893928,
        75.267806,
        23.749958,
        76.400792
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "nanded",
      "name": "Nanded",
      "key": "city_nanded_v2",
      "seo_city_key": "India|Nanded",
      "customer_city": "city_nanded_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Nanded",
        "nanded",
        "Nanded"
      ],
      "subcities": [
        "nanded"
      ],
      "city_address_hint": "48X9+JMW, Old Mondha, Hyder Bagh, Dashmesh Nagar, Harsh Nagar, Nanded-Waghala, Nanded, Maharashtra 431604, India",
      "url_name": "nanded",
      "country_name": "India",
      "postal_code": "431604",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 19.149086,
        "long": 77.319138,
        "details": "48X9+JMW, Old Mondha, Hyder Bagh, Dashmesh Nagar, Harsh Nagar, Nanded-Waghala, Nanded, Maharashtra 431604, India",
        "google_place_id": "ChIJC4DkcTjW0TsR4otE4OWuvOo"
      },
      "bounds": [
        19.084182,
        77.200413,
        19.25508,
        77.419624
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "gorakhpur",
      "name": "Gorakhpur",
      "key": "city_gorakhpur_v2",
      "seo_city_key": "India|Gorakhpur",
      "customer_city": "city_gorakhpur_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Gorakhpur",
        "gorakhpur",
        "Gorakhpur"
      ],
      "subcities": [
        "gorakhpur"
      ],
      "city_address_hint": "9FV2+MR9, Head Post Office Rd, Mallital, Nainital, Uttarakhand 263002, India",
      "url_name": "gorakhpur",
      "country_name": "India",
      "postal_code": "273010",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 29.394158,
        "long": 79.452278,
        "details": "9FV2+MR9, Head Post Office Rd, Mallital, Nainital, Uttarakhand 263002, India",
        "google_place_id": "ChIJaxhblZShoDkRdhbK6h5imjM"
      },
      "bounds": [
        26.16137,
        83.060589,
        27.476902,
        84.170551
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "naini Tal",
      "name": "Naini Tal",
      "key": "city_naini_tal_v2",
      "seo_city_key": "India|Naini Tal",
      "customer_city": "city_naini_tal_v2",
      "state": "Uttarakhand",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Naini Tal",
        "naini tal",
        "Naini Tal"
      ],
      "subcities": [
        "nainital"
      ],
      "city_address_hint": "9FR3+X96, Mallital, Nainital, Uttarakhand 263001, India",
      "url_name": "naini Tal",
      "country_name": "India",
      "postal_code": "263001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 29.3924139,
        "long": 79.4533773,
        "details": "9FR3+X96, Mallital, Nainital, Uttarakhand 263001, India",
        "google_place_id": "ChIJYZ39KLyhoDkRs32YFql7rnw"
      },
      "bounds": [
        28.815123,
        78.854284,
        29.484467,
        80.008192
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "bangalore",
      "name": "Bangalore",
      "key": "city_bangalore_v2",
      "seo_city_key": "india|bangalore",
      "customer_city": "city_bangalore_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "bangalore",
        "bengaluru",
        "arisinakunte"
      ],
      "subcities": [
        "Bangalore",
        "Bengaluru",
        "Bangalore Urban",
        "Arisinakunte",
        "bangalore"
      ],
      "city_address_hint": "3, Norris Rd, Richmond Town, Bengaluru, Karnataka 560025, India",
      "url_name": "bangalore",
      "country_name": "India",
      "postal_code": "560102",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 12.961947,
        "long": 77.603264,
        "details": "3, Norris Rd, Richmond Town, Bengaluru, Karnataka 560025, India",
        "google_place_id": "ChIJrT4dCtQVrjsRPRIJt171Zw8"
      },
      "bounds": [
        12.595999,
        77.376052,
        13.321696,
        77.895497
      ],
      "offices": [
        {
          "name": "Bangalore CO",
          "is_live": true,
          "address": "Municipal No. 21/345/335/SA No. 31/9/31/3,  4th Floor, Plot No. 31/9, Ropena Agarhara, Begur Hobli Hosur Main Road, Bengaluru, Karnataka 560068",
          "subcities": [
            "Bangalore",
            "Bangalore Urban",
            "Arisinakunte"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 12.913184,
            "long": 77.625833
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "delhi-ncr",
      "name": "Delhi NCR",
      "key": "city_delhi_v2",
      "seo_city_key": "india|new_delhi",
      "customer_city": "city_delhi_v2",
      "state": "Delhi",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "delhi",
        "new delhi",
        "gurgaon",
        "gurugram",
        "ghaziabad",
        "faridabad",
        "noida",
        "greater noida",
        "greater-noida",
        "greater_noida",
        "sarhol",
        "samalka",
        "narela",
        "nangloi jat",
        "najafgarh",
        "mahrauli",
        "jawaharnagar",
        "connaught place",
        "azadpur",
        "kair",
        "dwarka",
        "janakpuri",
        "civil lines",
        "libaspur",
        "burari",
        "mundka"
      ],
      "subcities": [
        "Delhi",
        "delhi",
        "Delhi-Ncr",
        "Noida",
        "Ghaziabad",
        "Faridabad",
        "Gurgaon",
        "Greater-Noida",
        "delhi-ncr",
        "noida",
        "ghaziabad",
        "faridabad",
        "gurgaon",
        "greater-noida",
        "Gurugram",
        "Sarhol",
        "sarhol",
        "New Delhi"
      ],
      "city_address_hint": "H37, Block H, Saket, New Delhi, Delhi 110017, India",
      "url_name": "delhi-ncr",
      "country_name": "India",
      "postal_code": "110049",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 28.52187,
        "long": 77.212384,
        "details": "H37, Block H, Saket, New Delhi, Delhi 110017, India",
        "google_place_id": "ChIJ5f4oMPLhDDkRPKXUvhZIiLY"
      },
      "bounds": [
        28.280194,
        76.841805,
        28.923427,
        77.61291
      ],
      "offices": [
        {
          "name": "Registered Office",
          "is_live": true,
          "address": "Unit No. 8, Ground Floor, Rectangle 1, D-4 Saket District Centre, New Delhi, 110 017, Delhi, India",
          "subcities": [
            "Delhi",
            "Delhi-Ncr",
            "Noida",
            "Ghaziabad",
            "Faridabad",
            "Gurgaon",
            "Greater-Noida",
            "Gurugram"
          ],
          "office_type": [
            "business",
            "support"
          ],
          "location_mapping": {
            "lat": 28.5271944,
            "long": 77.2166667
          }
        },
        {
          "name": "Corporate office",
          "is_live": true,
          "address": "7th & 8th Floor, Plot No. 183, Rajiv Nagar, Udyog Vihar, Sector 20, Gurugram, 122016, Haryana, India",
          "subcities": [
            "Delhi",
            "Delhi-Ncr",
            "Noida",
            "Ghaziabad",
            "Faridabad",
            "Gurgaon",
            "Greater-Noida",
            "Gurugram"
          ],
          "office_type": [
            "corporate",
            "training"
          ],
          "location_mapping": {
            "lat": 28.5125833,
            "long": 77.0843333
          }
        },
        {
          "name": "Gurgaon CO - 121",
          "is_live": true,
          "address": "Plot no. 121 , Udyog Vihar, Phase - 1, Gurgaon, Haryana - 122016",
          "subcities": [
            "Delhi",
            "Delhi-Ncr",
            "Noida",
            "Ghaziabad",
            "Faridabad",
            "Gurgaon",
            "Greater-Noida",
            "Gurugram"
          ],
          "office_type": [
            "business",
            "support"
          ],
          "location_mapping": {
            "lat": 28.5123611,
            "long": 77.0813889
          }
        },
        {
          "name": "Noida CO",
          "is_live": true,
          "address": "2nd Floor, A-21, Sector-60, Noida, UP-201301",
          "subcities": [
            "Delhi",
            "Delhi-Ncr",
            "Noida",
            "Ghaziabad",
            "Faridabad",
            "Gurgaon",
            "Greater-Noida",
            "Gurugram"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 28.602482732650078,
            "long": 77.36761528998157
          }
        },
        {
          "name": "Delhi CO",
          "is_live": true,
          "address": "2nd Floor, Plot no. 48, Rama Road, Najafgarh Road Industrial Area, Delhi 110015",
          "subcities": [
            "Delhi"
          ],
          "office_type": [
            "support",
            "training",
            "business",
            "corporate"
          ],
          "location_mapping": {
            "lat": 28.6636944,
            "long": 77.1597778
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "pune",
      "name": "Pune",
      "key": "city_pune_v2",
      "seo_city_key": "india|pune",
      "customer_city": "city_pune_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "pune",
        "pimpri-chinchwad"
      ],
      "subcities": [
        "Pune",
        "pune"
      ],
      "city_address_hint": "GW9W+9P4 Amanora Active Arena, Amanora Park Town, Hadapsar, Pune, Maharashtra 411028, India",
      "url_name": "pune",
      "country_name": "India",
      "postal_code": "411045",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 18.518146,
        "long": 73.947123,
        "details": "GW9W+9P4 Amanora Active Arena, Amanora Park Town, Hadapsar, Pune, Maharashtra 411028, India",
        "google_place_id": "ChIJN7j_LQDDwjsRlCZn5EqlGYg"
      },
      "bounds": [
        18.306619,
        73.626587,
        18.768996,
        74.180709
      ],
      "offices": [
        {
          "name": "Pune",
          "is_live": true,
          "address": "Urban Company Limited, Ground, 1st, 2nd, 3rd and 4th Floor, Survey no. 15/6/29, P Square Capital, off Bangalore Highway, Baner, Pune - 411045",
          "subcities": [
            "Pune"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 18.56292,
            "long": 73.764654
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ahmedabad",
      "name": "Ahmedabad",
      "key": "city_ahmedabad_v2",
      "seo_city_key": "india|ahmedabad",
      "customer_city": "city_ahmedabad_v2",
      "state": "Gujarat",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "ahmedabad",
        "gandhinagar"
      ],
      "subcities": [
        "Ahmedabad",
        "ahmedabad"
      ],
      "city_address_hint": "2GXH+RVC, Nilmani Society, Memnagar, Ahmedabad, Gujarat 380052, India",
      "url_name": "ahmedabad",
      "country_name": "India",
      "postal_code": "380051",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 23.049543,
        "long": 72.529454,
        "details": "2GXH+RVC, Nilmani Society, Memnagar, Ahmedabad, Gujarat 380052, India",
        "google_place_id": "ChIJVdC4A6-EXjkRLFrZu7mHi4o"
      },
      "bounds": [
        22.873552,
        72.296191,
        23.336158,
        72.874408
      ],
      "offices": [
        {
          "name": "Ahmedabad CO",
          "is_live": true,
          "address": "1501 to 1508, 15th Floor, Westgate Business Bay, B-1/Black, Makarba, Corporate Road, Ahmedabad, Gujrat- 380051",
          "subcities": [
            "Ahmedabad"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 22.99775,
            "long": 72.4996111
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "amritsar",
      "name": "Amritsar",
      "key": "city_amritsar_v2",
      "seo_city_key": "india|amritsar",
      "customer_city": "city_amritsar_v2",
      "state": "Punjab",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "amritsar",
        "Amritsar"
      ],
      "subcities": [
        "amritsar"
      ],
      "city_address_hint": "Golden Temple, Amritsar",
      "url_name": "amritsar",
      "country_name": "India",
      "postal_code": "143001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 31.6334677,
        "long": 74.7300352,
        "details": "Golden Temple, Amritsar",
        "google_place_id": "ChIJZwBQLlRjGTkR-6tJnPwIHAc"
      },
      "bounds": [
        31.123461,
        74.520653,
        31.83039,
        75.155109
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "hapur",
      "name": "Hapur",
      "key": "city_hapur_v2",
      "seo_city_key": "India|Hapur",
      "customer_city": "city_hapur_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Hapur",
        "hapur",
        "Hapur"
      ],
      "subcities": [
        "hapur",
        "Hapur"
      ],
      "city_address_hint": "01, Ganga Nagar Colony, Hapur, Uttar Pradesh 245101, India",
      "url_name": "hapur",
      "country_name": "India",
      "postal_code": "245101",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 28.73057979999999,
        "long": 77.7758825,
        "details": "01, Ganga Nagar Colony, Hapur, Uttar Pradesh 245101, India",
        "google_place_id": "ChIJo5BArKiFDDkR5jQ9ai8UVp0"
      },
      "bounds": [
        28.643218,
        77.632141,
        28.817379,
        78.038377
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "mahbubnagar",
      "name": "Mahbubnagar",
      "key": "city_mahbubnagar_v2",
      "seo_city_key": "India|Mahbubnagar",
      "customer_city": "city_mahbubnagar_v2",
      "state": "Telangana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Mahbubnagar",
        "mahbubnagar",
        "Mahbubnagar"
      ],
      "subcities": [
        "mahbubnagar"
      ],
      "city_address_hint": "PXXV+GMF, SH 18, Kidwaipet, Mahbubnagar, Telangana 509001",
      "url_name": "mahbubnagar",
      "country_name": "India",
      "postal_code": "509001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 16.7488379,
        "long": 78.00351719999999,
        "details": "PXXV+GMF, SH 18, Kidwaipet, Mahbubnagar, Telangana 509001",
        "google_place_id": "ChIJdaSu-gMmyjsRZfEKRG1n48Y"
      },
      "bounds": [
        16.334636,
        77.688661,
        17.15332,
        78.441009
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "guntur",
      "name": "Guntur",
      "key": "city_guntur_v2",
      "seo_city_key": "india|guntur",
      "customer_city": "city_guntur_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "guntur",
        "Guntur"
      ],
      "subcities": [
        "guntur"
      ],
      "city_address_hint": "The Chennai Shopping Mall, Guntur",
      "url_name": "guntur",
      "country_name": "India",
      "postal_code": "522002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 16.307974,
        "long": 80.43697,
        "details": "The Chennai Shopping Mall, Guntur",
        "google_place_id": "ChIJR88jlVx1SjoRCWKZ2ZVxlkk"
      },
      "bounds": [
        16.12445,
        80.251552,
        16.423365,
        80.712289
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "udaipur",
      "name": "Udaipur",
      "key": "city_udaipur_v2",
      "seo_city_key": "india|udaipur",
      "customer_city": "city_udaipur_v2",
      "state": "Rajasthan",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "udaipur"
      ],
      "subcities": [
        "Udaipur",
        "udaipur"
      ],
      "city_address_hint": "City Palace, Udaipur",
      "url_name": "udaipur",
      "country_name": "India",
      "postal_code": "313001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 24.577203,
        "long": 73.68351,
        "details": "City Palace, Udaipur",
        "google_place_id": "ChIJ1adZBmTlZzkRDqvq-navV5I"
      },
      "bounds": [
        24.112626,
        73.054808,
        25.085123,
        74.252324
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Kancheepuram",
      "name": "Kancheepuram",
      "key": "city_kancheepuram_v2",
      "seo_city_key": "India|Kancheepuram",
      "customer_city": "city_kancheepuram_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Kancheepuram",
        "kancheepuram",
        "Kancheepuram"
      ],
      "subcities": [],
      "city_address_hint": "Nellukara St, Nellukara st, Kanchipuram, Tamil Nadu 631501, India",
      "url_name": "Kancheepuram",
      "country_name": "India",
      "postal_code": "631501",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 12.8372508,
        "long": 79.7041749,
        "details": "Nellukara St, Nellukara st, Kanchipuram, Tamil Nadu 631501, India",
        "google_place_id": "ChIJLfHH4PfCUjoRTSrLsYKGX94"
      },
      "bounds": [
        12.746217,
        79.533782,
        12.948015,
        80.000545
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Guntur Rural",
      "name": "Guntur Rural",
      "key": "city_guntur_rural_v2",
      "seo_city_key": "India|Guntur Rural",
      "customer_city": "city_guntur_rural_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Guntur Rural"
      ],
      "subcities": [
        "guntur rural"
      ],
      "city_address_hint": "Guntur Rural, 522601",
      "url_name": "Guntur Rural",
      "country_name": "India",
      "postal_code": "522601",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 15.4776876,
        "long": 78.487285,
        "details": "Guntur Rural, 522601",
        "google_place_id": "ChIJTZKgRVCttTsRXSkVwnANISw"
      },
      "bounds": [
        16.132544,
        79.233029,
        16.682678,
        80.23368
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Karnataka_Central",
      "name": "Karnataka_Central",
      "key": "city_karnataka_central_v2",
      "seo_city_key": "India|Karnataka_Central",
      "customer_city": "city_karnataka_central_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Belagavi",
        "Ballari",
        "Vijayapura",
        "Bagalkote",
        "Hubbali"
      ],
      "subcities": [
        "Belagavi",
        "ballari",
        "Bagalkote",
        "Hubballi",
        "Vijayapura",
        "Gadag",
        "Haveri",
        "Chitradurga",
        "Koppal"
      ],
      "city_address_hint": "Postmaster, Post Office HUBLI (HEAD OFFICE), DHARWAD, KARNATAKA (KA), India (IN)",
      "url_name": "Karnataka_Central",
      "country_name": "India",
      "postal_code": "580020",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.70817,
        "long": 92.7211179,
        "details": "Postmaster, Post Office HUBLI (HEAD OFFICE), DHARWAD, KARNATAKA (KA), India (IN)",
        "google_place_id": "ChIJxVYP_Dq-iDARSdQXYYX4Og4"
      },
      "bounds": [
        14.590013,
        74.317884,
        16.4451,
        77.096475
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "thiruvallur",
      "name": "Thiruvallur",
      "key": "city_thiruvallur_v2",
      "seo_city_key": "India|Thiruvallur",
      "customer_city": "city_thiruvallur_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Thiruvallur",
        "thiruvallur",
        "Thiruvallur"
      ],
      "subcities": [
        "thiruvallur"
      ],
      "city_address_hint": "111, Egmore, Thiruvallur, Kakkalur, Tamil Nadu 602023, India",
      "url_name": "thiruvallur",
      "country_name": "India",
      "postal_code": "602001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 13.1230558,
        "long": 79.9119526,
        "details": "111, Egmore, Thiruvallur, Kakkalur, Tamil Nadu 602023, India",
        "google_place_id": "ChIJu37_EBeQUjoRtGgR-y9sEzg"
      },
      "bounds": [
        12.953699,
        79.802715,
        13.337785,
        80.027627
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "kurnool",
      "name": "Kurnool",
      "key": "city_kurnool_v2",
      "seo_city_key": "India|Kurnool",
      "customer_city": "city_kurnool_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Kurnool",
        "kurnool",
        "Kurnool"
      ],
      "subcities": [
        "kurnool"
      ],
      "city_address_hint": "R2HP+7W2, River View Colony, Kurnool, Andhra Pradesh 518004, India",
      "url_name": "kurnool",
      "country_name": "India",
      "postal_code": "518004",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 15.8281257,
        "long": 78.0372792,
        "details": "R2HP+7W2, River View Colony, Kurnool, Andhra Pradesh 518004, India",
        "google_place_id": "ChIJyca3BvXdtTsR8tZY-HSspxk"
      },
      "bounds": [
        15.127521,
        77.519289,
        16.098768,
        78.938656
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Mahesana",
      "name": "Mahesana",
      "key": "city_mahesana_v2",
      "seo_city_key": "India|Mahesana",
      "customer_city": "city_mahesana_v2",
      "state": "Gujarat",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Mahesana",
        "mahesana",
        "Mahesana"
      ],
      "subcities": [
        "Mahesana"
      ],
      "city_address_hint": "50, સદાનંદ નાગર, ભુવનેશ્વરી ટેબાઉપર, પાંચોટ, મહેસાણા, ગુજરાત 384002, India",
      "url_name": "Mahesana",
      "country_name": "India",
      "postal_code": "384002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 23.5879607,
        "long": 72.36932519999999,
        "details": "50, સદાનંદ નાગર, ભુવનેશ્વરી ટેબાઉપર, પાંચોટ, મહેસાણા, ગુજરાત 384002, India",
        "google_place_id": "ChIJ9Z54ryxCXDkR3Iu-uJC8Cxc"
      },
      "bounds": [
        23.439944,
        72.009708,
        24.074221,
        72.85238
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "gwalior",
      "name": "Gwalior",
      "key": "city_gwalior_v2",
      "seo_city_key": "india|gwalior",
      "customer_city": "city_gwalior_v2",
      "state": "Madhya Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "gwalior",
        "Gwalior"
      ],
      "subcities": [
        "gwalior"
      ],
      "city_address_hint": "Gwalior Zoo,’Gwalior",
      "url_name": "gwalior",
      "country_name": "India",
      "postal_code": "474007",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 26.214088,
        "long": 78.0508127,
        "details": "Gwalior Zoo,’Gwalior",
        "google_place_id": "ChIJqejUwSfEdjkRSqfBwqi0lFA"
      },
      "bounds": [
        25.959543,
        77.834232,
        26.533749,
        78.517006
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "kota",
      "name": "Kota",
      "key": "city_kota_v2",
      "seo_city_key": "india|kota",
      "customer_city": "city_kota_v2",
      "state": "Rajasthan",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "kota",
        "Kota"
      ],
      "subcities": [
        "kota"
      ],
      "city_address_hint": "Bharat Vikas Parishad Hospital, Kota",
      "url_name": "kota",
      "country_name": "India",
      "postal_code": "324009",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.1624838,
        "long": 75.8292584,
        "details": "Bharat Vikas Parishad Hospital, Kota",
        "google_place_id": "ChIJwViAk8qEbzkR_1327jfqb5E"
      },
      "bounds": [
        24.852267,
        75.623798,
        25.413758,
        76.164187
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Gurdaspur",
      "name": "Gurdaspur",
      "key": "city_gurdaspur_v2",
      "seo_city_key": "India|Gurdaspur",
      "customer_city": "city_gurdaspur_v2",
      "state": "Punjab",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Gurdaspur",
        "gurdaspur",
        "Gurdaspur"
      ],
      "subcities": [],
      "city_address_hint": "Jail Rd, Shaheed Bhagat Singh Nagar, Gurdaspur, Kotli Nangal, Punjab 143521, India",
      "url_name": "Gurdaspur",
      "country_name": "India",
      "postal_code": "143521",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 32.0413917,
        "long": 75.403086,
        "details": "Jail Rd, Shaheed Bhagat Singh Nagar, Gurdaspur, Kotli Nangal, Punjab 143521, India",
        "google_place_id": "ChIJbW6vtG2SGzkRi_mgraua2i8"
      },
      "bounds": [
        31.927391,
        75.114194,
        32.320694,
        75.774048
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Jhajjar",
      "name": "Jhajjar",
      "key": "city_jhajjar_v2",
      "seo_city_key": "India|Jhajjar",
      "customer_city": "city_jhajjar_v2",
      "state": "Haryana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Jhajjar",
        "jhajjar",
        "Jhajjar"
      ],
      "subcities": [],
      "city_address_hint": "JM43+5GR, Bhatti Gate, Jhajjar, Jhajjar, Jhajjarrural, Haryana 124103, India",
      "url_name": "Jhajjar",
      "country_name": "India",
      "postal_code": "124102",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 28.6054875,
        "long": 76.6537749,
        "details": "JM43+5GR, Bhatti Gate, Jhajjar, Jhajjar, Jhajjarrural, Haryana 124103, India",
        "google_place_id": "ChIJOdW99GVwDTkRETakusE0_0U"
      },
      "bounds": [
        28.496823,
        76.426063,
        28.947131,
        76.822875
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "amravati",
      "name": "Amravati",
      "key": "city_amravati_v2",
      "seo_city_key": "India|Amravati",
      "customer_city": "city_amravati_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Amravati",
        "amravati",
        "Amravati"
      ],
      "subcities": [
        "amravati"
      ],
      "city_address_hint": "9, Amrawati Tahsil, Ladtha Colony, Amravati, Maharashtra 444701, India",
      "url_name": "amravati",
      "country_name": "India",
      "postal_code": "444701",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 20.9319821,
        "long": 77.7523039,
        "details": "9, Amrawati Tahsil, Ladtha Colony, Amravati, Maharashtra 444701, India",
        "google_place_id": "ChIJFbx0d6ak1jsRNZZPyng_ezw"
      },
      "bounds": [
        20.590206,
        77.412071,
        21.600939,
        78.259735
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "warangal",
      "name": "Warangal",
      "key": "city_warangal_v2",
      "seo_city_key": "india|warangal",
      "customer_city": "city_warangal_v2",
      "state": "Telangana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "warangal",
        "Warangal"
      ],
      "subcities": [
        "warangal",
        "warangal urban",
        "warangal rural"
      ],
      "city_address_hint": "Kiwi Public School, Warangal",
      "url_name": "warangal",
      "country_name": "India",
      "postal_code": "506002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 17.97006,
        "long": 79.59272,
        "details": "Kiwi Public School, Warangal",
        "google_place_id": "ChIJNbbovTpFMzoRKooFPXdMwK8"
      },
      "bounds": [
        17.705984,
        79.32889,
        18.210891,
        79.895378
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "khammam",
      "name": "Khammam",
      "key": "city_khammam_v2",
      "seo_city_key": "india|khammam",
      "customer_city": "city_khammam_v2",
      "state": "Telangana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "khammam",
        "Khammam"
      ],
      "subcities": [
        "khammam"
      ],
      "city_address_hint": "South India Shopping Mall Khammam",
      "url_name": "khammam",
      "country_name": "India",
      "postal_code": "507001",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 17.24736,
        "long": 80.15072,
        "details": "South India Shopping Mall Khammam",
        "google_place_id": "ChIJ0eZEYz5ZNDoRfVnGYNv8VZc"
      },
      "bounds": [
        16.741569,
        80.029883,
        17.901629,
        80.873775
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Peddapalli",
      "name": "Peddapalli",
      "key": "city_peddapalli_v2",
      "seo_city_key": "India|Telangana",
      "customer_city": "city_peddapalli_v2",
      "state": "Telangana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Peddapalli",
        "peddapalli"
      ],
      "subcities": [
        "Peddapalli"
      ],
      "city_address_hint": "J9FH+HQ Peddapalli, Telangana, India",
      "url_name": "Peddapalli",
      "country_name": "India",
      "postal_code": "505172",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 18.623945,
        "long": 79.379389,
        "details": "J9FH+HQ Peddapalli, Telangana, India",
        "google_place_id": "GhIJsoAJ3LqfMkARal4f50fYU0A"
      },
      "bounds": [
        18.272044,
        78.772029,
        18.565571,
        79.356317
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "shimoga",
      "name": "Shimoga",
      "key": "city_shimoga_v2",
      "seo_city_key": "India|Shimoga",
      "customer_city": "city_shimoga_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Shimoga",
        "shimoga",
        "Shimoga"
      ],
      "subcities": [
        "shimoga"
      ],
      "city_address_hint": "18, 2nd Cross Rd, Vidyanagar, Madaripalya, Shivamogga, Karnataka 577201, India",
      "url_name": "shimoga",
      "country_name": "India",
      "postal_code": "577201",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 13.9299299,
        "long": 75.568101,
        "details": "18, 2nd Cross Rd, Vidyanagar, Madaripalya, Shivamogga, Karnataka 577201, India",
        "google_place_id": "ChIJlQRi7NCouzsRFxp2wjPXiVU"
      },
      "bounds": [
        13.638563,
        75.18781,
        14.187219,
        75.899048
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "vijayawada",
      "name": "Vijayawada",
      "key": "city_vijayawada_v2",
      "seo_city_key": "india|vijayawada",
      "customer_city": "city_vijayawada_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "vijayawada"
      ],
      "subcities": [
        "vijayawada",
        "Vijayawada"
      ],
      "city_address_hint": "PVR Ripples",
      "url_name": "vijayawada",
      "country_name": "India",
      "postal_code": "520010",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 16.5011,
        "long": 80.6436,
        "details": "PVR Ripples",
        "google_place_id": "ChIJS5QtSPnvNToRZQJKq4R-m5M"
      },
      "bounds": [
        16.426042,
        80.52211,
        16.65348,
        80.874964
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "tiruppur",
      "name": "Tiruppur",
      "key": "city_tiruppur_v2",
      "seo_city_key": "India|Tiruppur",
      "customer_city": "city_tiruppur_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Tiruppur",
        "tiruppur",
        "Tiruppur"
      ],
      "subcities": [
        "tiruppur"
      ],
      "city_address_hint": "8, Avinashi - Tiruppur Rd, PSS Colony, Bridge Way Colony, Tiruppur, Tamil Nadu 641602, India",
      "url_name": "tiruppur",
      "country_name": "India",
      "postal_code": "641603",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.109855,
        "long": 77.340875,
        "details": "8, Avinashi - Tiruppur Rd, PSS Colony, Bridge Way Colony, Tiruppur, Tamil Nadu 641602, India",
        "google_place_id": "ChIJoeXNBq8HqTsR49C4cDNwv6Y"
      },
      "bounds": [
        10.958888,
        77.147541,
        11.236664,
        77.629522
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Bamboo Flat",
      "name": "Koderma",
      "key": "city_koderma_v2",
      "seo_city_key": "India|Bamboo Flat",
      "customer_city": "city_koderma_v2",
      "state": "Jharkhand",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [],
      "subcities": [],
      "city_address_hint": "Post Office Kodarma SO (Sub-Office), Koderma, Jharkhand, India (IN), Pin Code: 825410",
      "url_name": "Bamboo Flat",
      "country_name": "India",
      "postal_code": "825410",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 11.70817,
        "long": 92.7211179,
        "details": "Post Office Kodarma SO (Sub-Office), Koderma, Jharkhand, India (IN), Pin Code: 825410",
        "google_place_id": "ChIJxVYP_Dq-iDARSdQXYYX4Og4"
      },
      "bounds": [
        24.217605,
        85.430635,
        24.480705,
        85.795616
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ranchi",
      "name": "Ranchi",
      "key": "city_ranchi_v2",
      "seo_city_key": "india|ranchi",
      "customer_city": "city_ranchi_v2",
      "state": "Jharkhand",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "ranchi"
      ],
      "subcities": [
        "ranchi"
      ],
      "city_address_hint": "Ashok Nagar",
      "url_name": "ranchi",
      "country_name": "India",
      "postal_code": "834002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 23.3431425,
        "long": 85.1812392,
        "details": "Ashok Nagar",
        "google_place_id": "ChIJ3bddqgTh9DkRPvSZaJ3UCdw"
      },
      "bounds": [
        23.12168,
        84.992415,
        23.581238,
        85.739487
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "nalanda",
      "name": "Nalanda",
      "key": "city_nalanda_v2",
      "seo_city_key": "India|Nalanda",
      "customer_city": "city_nalanda_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Nalanda",
        "nalanda",
        "Nalanda"
      ],
      "subcities": [
        "nalanda"
      ],
      "city_address_hint": "7F6H+VGF, Bihar 803118, India",
      "url_name": "nalanda",
      "country_name": "India",
      "postal_code": "803118",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.2621826,
        "long": 85.47880649999999,
        "details": "7F6H+VGF, Bihar 803118, India",
        "google_place_id": "ChIJWzXTxKX08jkRBvmewGrDf4c"
      },
      "bounds": [
        24.493022,
        85.249061,
        25.436086,
        85.832011
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "begusarai",
      "name": "Begusarai",
      "key": "city_begusarai_v2",
      "seo_city_key": "India|Begusarai",
      "customer_city": "city_begusarai_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Begusarai",
        "begusarai",
        "Begusarai"
      ],
      "subcities": [
        "begusarai"
      ],
      "city_address_hint": "Collegiate Rd, Vasant Vihar, Begusarai, Makhsaspur, Bihar 851101, India",
      "url_name": "begusarai",
      "country_name": "India",
      "postal_code": "851101",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.4181638,
        "long": 86.1271542,
        "details": "Collegiate Rd, Vasant Vihar, Begusarai, Makhsaspur, Bihar 851101, India",
        "google_place_id": "ChIJPVAc188a8jkRWK41dqe8PrY"
      },
      "bounds": [
        24.983737,
        85.900875,
        25.628864,
        86.739721
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "patna",
      "name": "Patna",
      "key": "city_patna_v2",
      "seo_city_key": "india|patna",
      "customer_city": "city_patna_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "patna",
        "Patna",
        "Patliputra",
        "patliputra"
      ],
      "subcities": [
        "patna",
        "Patna",
        "Patliputra",
        "patliputra"
      ],
      "city_address_hint": "S/9, Fraser Road, Budh Vihar, Fraser Road Area, Patna, Bihar 800001, India",
      "url_name": "patna",
      "country_name": "India",
      "postal_code": "800001",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 25.60806,
        "long": 85.137729,
        "details": "S/9, Fraser Road, Budh Vihar, Fraser Road Area, Patna, Bihar 800001, India",
        "google_place_id": "ChIJWTL7Ml1Y7TkReQwocOKcQsY"
      },
      "bounds": [
        25.44553,
        84.80473,
        25.655621,
        85.338226
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "purbi champaran",
      "name": "PURBI CHAMPARAN",
      "key": "city_purbi_champaran_v2",
      "seo_city_key": "India|Bettiah",
      "customer_city": "city_purbi_champaran_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "purbi champaran"
      ],
      "subcities": [
        "purbi champaran"
      ],
      "city_address_hint": "JV53+RQX, Turkauliya, Sankar Saraiya, Bihar 845437, India",
      "url_name": "purbi champaran",
      "country_name": "India",
      "postal_code": "845437",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 26.609755,
        "long": 84.854994,
        "details": "JV53+RQX, Turkauliya, Sankar Saraiya, Bihar 845437, India",
        "google_place_id": "ChIJr_R5K1UxkzkRfDE4xVuLGfc"
      },
      "bounds": [
        26.573789,
        84.306393,
        26.998437,
        85.013615
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "gaya",
      "name": "Gaya",
      "key": "city_gaya_v2",
      "seo_city_key": "India|Gaya",
      "customer_city": "city_gaya_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Gaya",
        "gaya",
        "Gaya"
      ],
      "subcities": [
        "gaya"
      ],
      "city_address_hint": "Q2R2+H3G, Nagmatia Colony, Gaya, Bihar 823001, India",
      "url_name": "gaya",
      "country_name": "India",
      "postal_code": "823001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 24.7913957,
        "long": 85.0002336,
        "details": "Q2R2+H3G, Nagmatia Colony, Gaya, Bihar 823001, India",
        "google_place_id": "ChIJHzwbCkQq8zkRpjS_vSOy9s4"
      },
      "bounds": [
        24.425661,
        83.934219,
        24.999394,
        85.218327
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "saran",
      "name": "Saran",
      "key": "city_saran_v2",
      "seo_city_key": "India|Saran",
      "customer_city": "city_saran_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Saran",
        "saran",
        "Saran"
      ],
      "subcities": [
        "saran"
      ],
      "city_address_hint": "VV44+9P Saiki, Bihar, India",
      "url_name": "saran",
      "country_name": "India",
      "postal_code": "841301",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.8559698,
        "long": 84.8567932,
        "details": "VV44+9P Saiki, Bihar, India",
        "google_place_id": "ChIJMUm2Xia7kjkRcjw9CoDga7s"
      },
      "bounds": [
        25.737737,
        84.634125,
        26.055164,
        85.041958
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "tumakuru",
      "name": "Tumakuru",
      "key": "city_tumakuru_v2",
      "seo_city_key": "India|Tumakuru",
      "customer_city": "city_tumakuru_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Tumakuru",
        "tumakuru",
        "Tumakuru"
      ],
      "subcities": [
        "tumakuru"
      ],
      "city_address_hint": "84Q8+5W4, Sri Shivakumaraswamiji Circle, S.S.Puram, Tumakuru, Karnataka 572103, India",
      "url_name": "tumakuru",
      "country_name": "India",
      "postal_code": "572103",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 13.3378762,
        "long": 77.117325,
        "details": "84Q8+5W4, Sri Shivakumaraswamiji Circle, S.S.Puram, Tumakuru, Karnataka 572103, India",
        "google_place_id": "ChIJuSMuYzsssDsRuzfX6TmyX-E"
      },
      "bounds": [
        13.208111,
        76.349058,
        13.701149,
        77.344907
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "davanagere",
      "name": "Davanagere",
      "key": "city_davanagere_v2",
      "seo_city_key": "India|Davanagere",
      "customer_city": "city_davanagere_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Davanagere",
        "davanagere",
        "Davanagere"
      ],
      "subcities": [
        "davanagere"
      ],
      "city_address_hint": "023 Kusanur, KTJ Nagar, Nittuvalli, Davanagere, Karnataka 577002, India",
      "url_name": "davanagere",
      "country_name": "India",
      "postal_code": "577002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 14.4644085,
        "long": 75.921758,
        "details": "023 Kusanur, KTJ Nagar, Nittuvalli, Davanagere, Karnataka 577002, India",
        "google_place_id": "ChIJ5SJianIlujsRctTGR-ENEko"
      },
      "bounds": [
        14.231273,
        75.70816,
        14.531079,
        75.966511
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ysr",
      "name": "Y.S.R",
      "key": "city_kadapa_v2",
      "seo_city_key": "India|ysr",
      "customer_city": "city_kadapa_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "ysr"
      ],
      "subcities": [
        "ysr"
      ],
      "city_address_hint": "2/417, Maria Puram, Nagarajupeta, Kadapa, Andhra Pradesh 516001, India",
      "url_name": "ysr",
      "country_name": "India",
      "postal_code": "516001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 14.467722,
        "long": 78.823595,
        "details": "2/417, Maria Puram, Nagarajupeta, Kadapa, Andhra Pradesh 516001, India",
        "google_place_id": "ChIJyX5hcBFyszsRzResEfLKkc4"
      },
      "bounds": [
        13.824788,
        78.309731,
        15.053102,
        79.312363
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "anantapur",
      "name": "Anantapur",
      "key": "city_anantapur_v2",
      "seo_city_key": "India|Anantapur",
      "customer_city": "city_anantapur_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Anantapur",
        "anantapur",
        "Anantapur"
      ],
      "subcities": [
        "anantapur"
      ],
      "city_address_hint": "1-1348-1, opposite Sakshi Office, Kamalanagar, Anantapur, Andhra Pradesh 515001, India",
      "url_name": "anantapur",
      "country_name": "India",
      "postal_code": "515001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 14.6818877,
        "long": 77.6005911,
        "details": "1-1348-1, opposite Sakshi Office, Kamalanagar, Anantapur, Andhra Pradesh 515001, India",
        "google_place_id": "ChIJN09A5sJKsTsR6HDO4mTQELg"
      },
      "bounds": [
        13.768052,
        77.103101,
        15.118533,
        78.16359
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "dubai",
      "name": "Dubai",
      "key": "city_dubai_v2",
      "seo_city_key": "united_arab_emirates|dubai",
      "customer_city": "city_dubai_v2",
      "state": "Dubai",
      "country_key": "UAE",
      "country_id": "UAE",
      "regex": [
        "dubai",
        "???",
        "jumayra",
        "emirates hill second",
        "bur dubai",
        "mirdif"
      ],
      "subcities": [
        "Dubai",
        "dubai",
        "???"
      ],
      "city_address_hint": "1 Sheikh Mohammed bin Rashid Blvd - Dubai - United Arab Emirates",
      "url_name": "dubai",
      "country_name": "UAE",
      "postal_code": "380051",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 25.1975148,
        "long": 55.2748732,
        "details": "1 Sheikh Mohammed bin Rashid Blvd - Dubai - United Arab Emirates",
        "google_place_id": "ChIJ2Y-H54FCXz4R2gdP3D5Mk24"
      },
      "bounds": [
        24.85799,
        54.97693,
        25.29843,
        55.62406
      ],
      "offices": [
        {
          "name": "UAE",
          "is_live": true,
          "address": "2002 - Cluster F - Al Thanyah Fifth - Jumeirah Lakes Towers - Dubai - United Arab",
          "subcities": [
            "Dubai"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 25.075416,
            "long": 55.145625
          }
        }
      ],
      "timezone": "Asia/Dubai"
    },
    {
      "is_live": true,
      "regex_key": "Siddipet",
      "name": "Siddipet",
      "key": "city_siddipet_v2",
      "seo_city_key": "India|Siddipet",
      "customer_city": "city_siddipet_v2",
      "state": "Telangana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Siddipet",
        "siddipet"
      ],
      "subcities": [
        "siddipet"
      ],
      "city_address_hint": "5QFR+6H Mallyal, Telangana, India",
      "url_name": "Siddipet",
      "country_name": "India",
      "postal_code": "502114",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 18.173069,
        "long": 78.79149,
        "details": "5QFR+6H Mallyal, Telangana, India",
        "google_place_id": "GhIJwHebN04sMkARembuxqeyU0A"
      },
      "bounds": [
        17.7976,
        78.420238,
        18.21514,
        79.215573
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Hazaribagh",
      "name": "Hazaribagh",
      "key": "city_hazaribagh_v2",
      "seo_city_key": "India|Hazaribagh",
      "customer_city": "city_hazaribagh_v2",
      "state": "Jharkhand",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Hazaribagh",
        "hazaribagh",
        "Hazaribagh"
      ],
      "subcities": [],
      "city_address_hint": "X9R7+XFM, Suresh Colony, Hazaribagh, Jharkhand 825301, India",
      "url_name": "Hazaribagh",
      "country_name": "India",
      "postal_code": "825301",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 23.9924669,
        "long": 85.3636758,
        "details": "X9R7+XFM, Suresh Colony, Hazaribagh, Jharkhand 825301, India",
        "google_place_id": "ChIJj1QmTxGc9DkRH5Zhu2joRb0"
      },
      "bounds": [
        23.633359,
        85.142798,
        24.189666,
        85.729752
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Chhindwara",
      "name": "Chhindwara",
      "key": "city_chhindwara_v2",
      "seo_city_key": "India|Chhindwara",
      "customer_city": "city_chhindwara_v2",
      "state": "Madhya Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Chhindwara",
        "chhindwara",
        "Chhindwara"
      ],
      "subcities": [
        "chhindwara",
        "betul"
      ],
      "city_address_hint": "3W4Q+X7F, Rautha Wada, Chhindwara, Madhya Pradesh 480001, India",
      "url_name": "Chhindwara",
      "country_name": "India",
      "postal_code": "480001",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 22.057437,
        "long": 78.9381729,
        "details": "3W4Q+X7F, Rautha Wada, Chhindwara, Madhya Pradesh 480001, India",
        "google_place_id": "ChIJ5RJ8bhxm1TsRz5Zo0YUyzKI"
      },
      "bounds": [
        21.683664,
        78.665612,
        22.326174,
        79.535675
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ajmer",
      "name": "Ajmer",
      "key": "city_ajmer_v2",
      "seo_city_key": "India|Ajmer",
      "customer_city": "city_ajmer_v2",
      "state": "Rajasthan",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ajmer",
        "ajmer",
        "Ajmer"
      ],
      "subcities": [
        "ajmer"
      ],
      "city_address_hint": "CJXQ+XX3, Nalasopra, Subhash Nagar, Ajmer, Rajasthan 305001, India",
      "url_name": "ajmer",
      "country_name": "India",
      "postal_code": "305001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 26.4498954,
        "long": 74.6399163,
        "details": "CJXQ+XX3, Nalasopra, Subhash Nagar, Ajmer, Rajasthan 305001, India",
        "google_place_id": "ChIJAc23_NjmazkR7gCB6xKPr8s"
      },
      "bounds": [
        25.925153,
        74.165549,
        26.841814,
        75.28166
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "purba bardhaman",
      "name": "PURBA BARDHAMAN",
      "key": "city_purba_bardhaman_v2",
      "seo_city_key": "India|PURBA BARDHAMAN",
      "customer_city": "city_purba_bardhaman_v2",
      "state": "West Bengal",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "PURBA BARDHAMAN",
        "Murshidabad",
        "Nadia",
        "Bokharo",
        "Dhanbad",
        "Girdhi",
        "Birbhum",
        "Paschim Bardhaman",
        "Bankura",
        "Purulia"
      ],
      "subcities": [
        "Murshidabad",
        "Paschim Bardhaman",
        "Nadia",
        "Purba Bardhaman",
        "Purulia",
        "Bokharo",
        "Dhanbad",
        "Girdhi",
        "Birbhum",
        "Bankura"
      ],
      "city_address_hint": "PX9M+PF Komarpur, West Bengal, India",
      "url_name": "purba bardhaman",
      "country_name": "India",
      "postal_code": "713129",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 23.719331,
        "long": 87.983743,
        "details": "PX9M+PF Komarpur, West Bengal, India",
        "google_place_id": "GhIJOn2YGCa4N0ARZOoJpvX-VUA"
      },
      "bounds": [
        23.01165,
        85.84176,
        24.828066,
        88.91231
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jodhpur",
      "name": "Jodhpur",
      "key": "city_jodhpur_v2",
      "seo_city_key": "india|jodhpur",
      "customer_city": "city_jodhpur_v2",
      "state": "Rajasthan",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "jodhpur",
        "Jodhpur"
      ],
      "subcities": [
        "jodhpur"
      ],
      "city_address_hint": "Umaid Bhawan Palace, Jodhpur",
      "url_name": "jodhpur",
      "country_name": "India",
      "postal_code": "342001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 26.281741,
        "long": 73.047345,
        "details": "Umaid Bhawan Palace, Jodhpur",
        "google_place_id": "ChIJ1adZBmTlZzkRDqvq-navV5I"
      },
      "bounds": [
        25.583637,
        71.920211,
        28.990123,
        73.948732
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "banas Kantha",
      "name": "Banas Kantha",
      "key": "city_banas_kantha_v2",
      "seo_city_key": "India|Banas Kantha",
      "customer_city": "city_banas_kantha_v2",
      "state": "Gujarat",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Banas Kantha",
        "banas kantha",
        "Banas Kantha"
      ],
      "subcities": [
        "banas Kantha",
        "palanpur",
        "deesa"
      ],
      "city_address_hint": "8QW6+5VQ, Peparal, Gujarat 385310, India",
      "url_name": "banas Kantha",
      "country_name": "India",
      "postal_code": "385001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 24.3454739,
        "long": 71.7622481,
        "details": "8QW6+5VQ, Peparal, Gujarat 385310, India",
        "google_place_id": "ChIJiTGoOkPpXDkRZ5ScxWXN7aQ"
      },
      "bounds": [
        24.243232,
        72.156047,
        24.562744,
        72.64356
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Satna",
      "name": "Satna",
      "key": "city_satna_v2",
      "seo_city_key": "India|Satna",
      "customer_city": "city_satna_v2",
      "state": "Madhya Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "satna"
      ],
      "subcities": [],
      "city_address_hint": "Jaistambh Chowk, Bajaraha Tola, Ganpat Marg, Nazirabad, Satna, Madhya Pradesh 485001",
      "url_name": "Satna",
      "country_name": "India",
      "postal_code": "485001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 24.609759,
        "long": 80.824819,
        "details": "Jaistambh Chowk, Bajaraha Tola, Ganpat Marg, Nazirabad, Satna, Madhya Pradesh 485001",
        "google_place_id": "GhIJ5_HFKBmcOEARmGa618k0VEA"
      },
      "bounds": [
        24.193926,
        80.476622,
        24.83905,
        81.385606
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Sagar",
      "name": "sagar",
      "key": "city_sagar_v2",
      "seo_city_key": "India|Sagar",
      "customer_city": "city_sagar_v2",
      "state": "Madhya pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "sagar"
      ],
      "subcities": [],
      "city_address_hint": "RQW6+7FJ, opp. so bownglow, Sagar Cantt., Sagar, Madhya Pradesh 470001",
      "url_name": "Sagar",
      "country_name": "India",
      "postal_code": "470001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.70817,
        "long": 92.7211179,
        "details": "RQW6+7FJ, opp. so bownglow, Sagar Cantt., Sagar, Madhya Pradesh 470001",
        "google_place_id": "ChIJxVYP_Dq-iDARSdQXYYX4Og4"
      },
      "bounds": [
        23.3114,
        78.141936,
        24.480306,
        79.449357
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Bhilwara",
      "name": "Bhilwara",
      "key": "city_bhilwara_v2",
      "seo_city_key": "India|Bhilwara",
      "customer_city": "city_bhilwara_v2",
      "state": "Rajasthan",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Bhilwara",
        "bhilwara",
        "Bhilwara"
      ],
      "subcities": [
        "bhilwara"
      ],
      "city_address_hint": "8JRJ+7GW, Pratap Nagar, Bhilwara, Rajasthan 311001, India",
      "url_name": "Bhilwara",
      "country_name": "India",
      "postal_code": "311001",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 25.3407388,
        "long": 74.63131829999999,
        "details": "8JRJ+7GW, Pratap Nagar, Bhilwara, Rajasthan 311001, India",
        "google_place_id": "ChIJVQoHjDbCaDkRlFLLLaRwL8k"
      },
      "bounds": [
        24.825651,
        74.26629,
        25.766,
        75.202489
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jalandhar",
      "name": "Jalandhar",
      "key": "city_jalandhar_v2",
      "seo_city_key": "India|Jalandhar",
      "customer_city": "city_jalandhar_v2",
      "state": "Punjab",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Jalandhar",
        "jalandhar",
        "Jalandhar"
      ],
      "subcities": [
        "jalandhar"
      ],
      "city_address_hint": "198, Fatehpur, Civil Line, Jalandhar, Makhdoom Pura, Punjab 144001, India",
      "url_name": "jalandhar",
      "country_name": "India",
      "postal_code": "144001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 31.3260152,
        "long": 75.57618289999999,
        "details": "198, Fatehpur, Civil Line, Jalandhar, Makhdoom Pura, Punjab 144001, India",
        "google_place_id": "ChIJkeupR1daGjkRuLSlWsA0S8c"
      },
      "bounds": [
        31.071416,
        75.212659,
        31.758105,
        76.132421
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "baleshwar",
      "name": "Baleshwar",
      "key": "city_baleshwar_v2",
      "seo_city_key": "India|Baleshwar",
      "customer_city": "city_baleshwar_v2",
      "state": "Odisha",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Baleshwar",
        "baleshwar",
        "Baleshwar"
      ],
      "subcities": [
        "baleshwar"
      ],
      "city_address_hint": "FWV7+89 Balasore, Odisha, India",
      "url_name": "baleshwar",
      "country_name": "India",
      "postal_code": "756060",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 21.4933578,
        "long": 86.9134794,
        "details": "FWV7+89 Balasore, Odisha, India",
        "google_place_id": "ChIJNeA28IRfHDoRfBVwHL8y01w"
      },
      "bounds": [
        20.567765,
        84.975224,
        22.596209,
        87.125881
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Shahjhanpur",
      "name": "Shahjhanpur",
      "key": "city_shahjhanpur_v2",
      "seo_city_key": "India|Bamboo Flat",
      "customer_city": "city_shahjhanpur_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Shahjhanpur"
      ],
      "subcities": [],
      "city_address_hint": "VWR9+6C8, GF College Rd, Cantt Area, Chinnor, Shahjahanpur, Uttar Pradesh 242001",
      "url_name": "Shahjhanpur",
      "country_name": "India",
      "postal_code": "242001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.70817,
        "long": 92.7211179,
        "details": "VWR9+6C8, GF College Rd, Cantt Area, Chinnor, Shahjahanpur, Uttar Pradesh 242001",
        "google_place_id": "ChIJxVYP_Dq-iDARSdQXYYX4Og4"
      },
      "bounds": [
        27.728184,
        79.759356,
        27.999972,
        80.045703
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Kheri",
      "name": "Kheri",
      "key": "city_kheri_v2",
      "seo_city_key": "India|Kheri",
      "customer_city": "city_kheri_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Kheri"
      ],
      "subcities": [],
      "city_address_hint": "00, Hiralal Dhramshala, Khaprel Bazar, Lakhimpur, Uttar Pradesh 262701, India",
      "url_name": "Kheri",
      "country_name": "India",
      "postal_code": "262701",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 27.946149,
        "long": 80.778618,
        "details": "00, Hiralal Dhramshala, Khaprel Bazar, Lakhimpur, Uttar Pradesh 262701, India",
        "google_place_id": "ChIJr63ADXc1nzkRVBZkPnrBGwk"
      },
      "bounds": [
        27.444565,
        80.374398,
        28.334717,
        81.067004
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jabalpur",
      "name": "Jabalpur",
      "key": "city_jabalpur_v2",
      "seo_city_key": "india|jabalpur",
      "customer_city": "city_jabalpur_v2",
      "state": "Madhya Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "jabalpur",
        "jubbulpore"
      ],
      "subcities": [
        "jabalpur",
        "Jabalpur"
      ],
      "city_address_hint": "Nehru Park",
      "url_name": "jabalpur",
      "country_name": "India",
      "postal_code": "482009",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 23.1758374,
        "long": 79.8987131,
        "details": "Nehru Park",
        "google_place_id": "ChIJfam2DxqugTkRueNDvBYGAkQ"
      },
      "bounds": [
        22.951132,
        79.58178,
        23.537484,
        80.220932
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "erode",
      "name": "Erode",
      "key": "city_erode_v2",
      "seo_city_key": "India|Erode",
      "customer_city": "city_erode_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Erode",
        "erode",
        "Erode"
      ],
      "subcities": [
        "erode"
      ],
      "city_address_hint": "26, Thiyagi Kumaran St, Municipal Colony, Muncipal Colony, Edayankattuvalasu, Erode, Tamil Nadu 638004, India",
      "url_name": "erode",
      "country_name": "India",
      "postal_code": "638009",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.343653,
        "long": 77.715752,
        "details": "26, Thiyagi Kumaran St, Municipal Colony, Muncipal Colony, Edayankattuvalasu, Erode, Tamil Nadu 638004, India",
        "google_place_id": "ChIJD2J3OjpvqTsRhPdfVam8tP0"
      },
      "bounds": [
        11.247776,
        77.469835,
        11.598179,
        77.910833
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "raigad",
      "name": "raigad",
      "key": "city_murud_(raigad)_v2",
      "seo_city_key": "India|Raigad",
      "customer_city": "city_murud_(raigad)_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "raigad"
      ],
      "subcities": [
        "raigad"
      ],
      "city_address_hint": "Near, Beach Rd, Murud, Maharashtra 402401, India",
      "url_name": "raigad",
      "country_name": "India",
      "postal_code": "402401",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 18.331926,
        "long": 72.9608202,
        "details": "Near, Beach Rd, Murud, Maharashtra 402401, India",
        "google_place_id": "ChIJd_v8spFD6DsR-fbJM21_LAY"
      },
      "bounds": [
        17.894197,
        72.856064,
        18.879152,
        73.576871
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Thrissur",
      "name": "Thrissur",
      "key": "city_thrissur_v2",
      "seo_city_key": "India|Thrissur",
      "customer_city": "city_thrissur_v2",
      "state": "Kerala",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Thrissur",
        "thrissur",
        "Thrissur"
      ],
      "subcities": [],
      "city_address_hint": "Kachery, G6H7+3Q3, Round North, Thrissur, Kerala 680020, India",
      "url_name": "Thrissur",
      "country_name": "India",
      "postal_code": "680007",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 10.5276416,
        "long": 76.2144349,
        "details": "Kachery, G6H7+3Q3, Round North, Thrissur, Kerala 680020, India",
        "google_place_id": "ChIJu9FC7RXupzsR26dsAapFLgg"
      },
      "bounds": [
        10.362043,
        75.953293,
        10.704545,
        76.384718
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "kochi",
      "name": "Kochi",
      "key": "city_kochi_v2",
      "seo_city_key": "india|kochi",
      "customer_city": "city_kochi_v2",
      "state": "Kerala",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "kochi",
        "cochin"
      ],
      "subcities": [
        "kochi",
        "Kochi",
        "cochin"
      ],
      "city_address_hint": "1737B, P T Jacob Rd, Kazhuthumuttu, Mundamveli, Kochi, Kerala 682507, India",
      "url_name": "kochi",
      "country_name": "India",
      "postal_code": "682016",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 9.935514,
        "long": 76.251505,
        "details": "1737B, P T Jacob Rd, Kazhuthumuttu, Mundamveli, Kochi, Kerala 682507, India",
        "google_place_id": "ChIJ56-gvHNtCDsRfGzXkiai0mE"
      },
      "bounds": [
        9.24619,
        76.118513,
        10.32654,
        76.43455
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "varanasi",
      "name": "Varanasi",
      "key": "city_varanasi_v2",
      "seo_city_key": "india|varanasi",
      "customer_city": "city_varanasi_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Varanasi",
        "Banaras",
        "varanasi",
        "banaras"
      ],
      "subcities": [
        "Varanasi",
        "Banaras",
        "varanasi",
        "banaras"
      ],
      "city_address_hint": "8XGP+WQ3, Railwayganj Colony, Varanasi, Uttar Pradesh 221002, India",
      "url_name": "varanasi",
      "country_name": "India",
      "postal_code": "221002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.327182,
        "long": 82.987021,
        "details": "8XGP+WQ3, Railwayganj Colony, Varanasi, Uttar Pradesh 221002, India",
        "google_place_id": "ChIJyQ3HhnwtjjkRQjKhUNHgWQo"
      },
      "bounds": [
        25.209263,
        82.84908,
        25.47825,
        83.102871
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "salem",
      "name": "Salem",
      "key": "city_salem_v2",
      "seo_city_key": "India|Salem",
      "customer_city": "city_salem_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Salem",
        "salem",
        "Salem"
      ],
      "subcities": [
        "salem"
      ],
      "city_address_hint": "211, Omalur Main Rd, next to Tanishq Jewellery, Parvathipuram, Indian Bank Colony, Arisipalayam, Salem, Tamil Nadu 636004, India",
      "url_name": "salem",
      "country_name": "India",
      "postal_code": "636005",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.664325,
        "long": 78.1460142,
        "details": "211, Omalur Main Rd, next to Tanishq Jewellery, Parvathipuram, Indian Bank Colony, Arisipalayam, Salem, Tamil Nadu 636004, India",
        "google_place_id": "ChIJC7os9czxqzsRR8pocACJme4"
      },
      "bounds": [
        11.472623,
        77.927166,
        12.201448,
        78.614474
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "nizamabad",
      "name": "Nizamabad",
      "key": "city_nizamabad_v2",
      "seo_city_key": "India|Nizamabad",
      "customer_city": "city_nizamabad_v2",
      "state": "Telangana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Khanapur",
        "khanapur",
        "Khanapur"
      ],
      "subcities": [
        "nizamabad"
      ],
      "city_address_hint": "7-11-574, NRI Colony, Arsapally, Nizamabad, Telangana 503001, India",
      "url_name": "nizamabad",
      "country_name": "India",
      "postal_code": "503003",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 18.676086,
        "long": 78.088272,
        "details": "7-11-574, NRI Colony, Arsapally, Nizamabad, Telangana 503001, India",
        "google_place_id": "ChIJCZoQVz3bzTsRow5k8-Bk-ns"
      },
      "bounds": [
        18.489863,
        77.846546,
        19.023174,
        78.543062
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "wardha",
      "name": "Wardha",
      "key": "city_wardha_v2",
      "seo_city_key": "India|Wardha",
      "customer_city": "city_wardha_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Wardha",
        "wardha",
        "Wardha"
      ],
      "subcities": [
        "wardha"
      ],
      "city_address_hint": "9175241566, Mahadevpura, Wardha, Maharashtra 442001, India",
      "url_name": "wardha",
      "country_name": "India",
      "postal_code": "442001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 20.745319,
        "long": 78.60219459999999,
        "details": "9175241566, Mahadevpura, Wardha, Maharashtra 442001, India",
        "google_place_id": "ChIJnaZa8QR_1DsRbKaCM7E1buc"
      },
      "bounds": [
        20.539463,
        78.300685,
        20.905126,
        79.327747
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "surat",
      "name": "Surat",
      "key": "city_surat_v2",
      "seo_city_key": "india|surat",
      "customer_city": "city_surat_v2",
      "state": "Gujarat",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "surat"
      ],
      "subcities": [
        "Surat",
        "surat"
      ],
      "city_address_hint": "Athwa Gate, Surat",
      "url_name": "surat",
      "country_name": "India",
      "postal_code": "395003",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 21.18589,
        "long": 76.7794179,
        "details": "Athwa Gate, Surat",
        "google_place_id": "ChIJ5wmyqHBO4DsRVlAXm_9D-ZU"
      },
      "bounds": [
        21.047248,
        72.555871,
        21.430611,
        73.162184
      ],
      "offices": [
        {
          "name": "Surat",
          "is_live": false,
          "address": "318, 3rd Floor, Exult Shoppers, Nr. Siddhivinayak Temple, Vesu Main Road, Surat, Gujarat 395007",
          "subcities": [
            "Surat"
          ],
          "office_type": [
            "corporate"
          ],
          "location_mapping": {
            "lat": 21.18589,
            "long": 76.7794179
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Ghazipur",
      "name": "Ghazipur",
      "key": "city_ghazipur_v2",
      "seo_city_key": "India|Ghazipur",
      "customer_city": "city_ghazipur_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ghazipur",
        "ghazipur",
        "Ghazipur"
      ],
      "subcities": [
        "ghazipur"
      ],
      "city_address_hint": "1425, Phatehpur, Rauza, Chak Bhikhari, Ghazipur, Uttar Pradesh 233001, India",
      "url_name": "Ghazipur",
      "country_name": "India",
      "postal_code": "233001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.5877901,
        "long": 83.5783078,
        "details": "1425, Phatehpur, Rauza, Chak Bhikhari, Ghazipur, Uttar Pradesh 233001, India",
        "google_place_id": "ChIJv98LNXj_kTkRhjVQwFEkp8Q"
      },
      "bounds": [
        25.364968,
        83.187618,
        25.849423,
        83.7117
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "bharuch",
      "name": "Bharuch",
      "key": "city_bharuch_v2",
      "seo_city_key": "India|Bharuch",
      "customer_city": "city_bharuch_v2",
      "state": "Gujarat",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Bharuch",
        "bharuch",
        "Bharuch"
      ],
      "subcities": [
        "bharuch"
      ],
      "city_address_hint": "PX4W+389, Moficer Jin Compound, Bharuch, Gujarat 392001, India",
      "url_name": "bharuch",
      "country_name": "India",
      "postal_code": "392001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 21.7051358,
        "long": 72.9958748,
        "details": "PX4W+389, Moficer Jin Compound, Bharuch, Gujarat 392001, India",
        "google_place_id": "ChIJIcQqsqIg4DsRKv0iRkJsEaQ"
      },
      "bounds": [
        21.440127,
        72.502727,
        22.024068,
        73.444107
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "sambalpur",
      "name": "Sambalpur",
      "key": "city_sambalpur_v2",
      "seo_city_key": "India|Sambalpur",
      "customer_city": "city_sambalpur_v2",
      "state": "Odisha",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Sambalpur",
        "sambalpur",
        "Sambalpur"
      ],
      "subcities": [
        "sambalpur"
      ],
      "city_address_hint": "FX8J+PFV, Sakhipara, Sambalpur, Odisha 768001, India",
      "url_name": "sambalpur",
      "country_name": "India",
      "postal_code": "768001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 21.4668716,
        "long": 83.9811665,
        "details": "FX8J+PFV, Sakhipara, Sambalpur, Odisha 768001, India",
        "google_place_id": "ChIJtdl8BH8WIToRVdaE5gukYHY"
      },
      "bounds": [
        21.144951,
        83.215944,
        22.331688,
        84.945648
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Khandwa",
      "name": "Khandwa",
      "key": "city_khandwa_v2",
      "seo_city_key": "India|Khandwa",
      "customer_city": "city_khandwa_v2",
      "state": "Madhya Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Khandwa",
        "khandwa",
        "Khandwa"
      ],
      "subcities": [
        "khandwa"
      ],
      "city_address_hint": "51, Azad Nagar, Anand Nagar, Khandwa, Madhya Pradesh 450001, India",
      "url_name": "Khandwa",
      "country_name": "India",
      "postal_code": "450001",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 21.8314037,
        "long": 76.3497612,
        "details": "51, Azad Nagar, Anand Nagar, Khandwa, Madhya Pradesh 450001, India",
        "google_place_id": "ChIJjeDBDG4b2DsRIzq-AqxGH8I"
      },
      "bounds": [
        21.603614,
        75.904856,
        22.284811,
        76.938676
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "nagpur",
      "name": "Nagpur",
      "key": "city_nagpur_v2",
      "seo_city_key": "india|nagpur",
      "customer_city": "city_nagpur_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "nagpur"
      ],
      "subcities": [
        "Nagpur",
        "nagpur"
      ],
      "city_address_hint": "Dhantoli, Nagpur",
      "url_name": "nagpur",
      "country_name": "India",
      "postal_code": "440001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 21.13344,
        "long": 79.08376,
        "details": "Dhantoli, Nagpur",
        "google_place_id": "ChIJ1esbupDA1DsR7_vQpJKicDU"
      },
      "bounds": [
        20.993155,
        78.587565,
        21.460079,
        79.502646
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "kolhapur",
      "name": "Kolhapur",
      "key": "city_kolhapur_v2",
      "seo_city_key": "India|Kolhapur",
      "customer_city": "city_kolhapur_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Kolhapur",
        "kolhapur",
        "Kolhapur"
      ],
      "subcities": [
        "kolhapur"
      ],
      "city_address_hint": "1116, opp. Panch Bungalow, E Ward, Shahupuri, Kolhapur, Maharashtra 416001, India",
      "url_name": "kolhapur",
      "country_name": "India",
      "postal_code": "416001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 16.7049873,
        "long": 74.24325270000001,
        "details": "1116, opp. Panch Bungalow, E Ward, Shahupuri, Kolhapur, Maharashtra 416001, India",
        "google_place_id": "ChIJKXrA3gwAwTsRL-RSKWTq6Ow"
      },
      "bounds": [
        16.561859,
        73.902197,
        17.173103,
        74.382591
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "sangli",
      "name": "Sangli",
      "key": "city_sangli_v2",
      "seo_city_key": "India|Sangli",
      "customer_city": "city_sangli_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Sangli",
        "sangli",
        "Sangli"
      ],
      "subcities": [
        "sangli"
      ],
      "city_address_hint": "321, South Shivaji Nagar, Nishant Colony, Sangli Miraj Kupwad, Sangli, Maharashtra 416416, India",
      "url_name": "sangli",
      "country_name": "India",
      "postal_code": "416415",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 16.8523973,
        "long": 74.5814773,
        "details": "321, South Shivaji Nagar, Nishant Colony, Sangli Miraj Kupwad, Sangli, Maharashtra 416416, India",
        "google_place_id": "ChIJ62Dwh4EMwTsRs93BzVMfkTc"
      },
      "bounds": [
        16.574668,
        74.384436,
        17.159736,
        75.064601
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "chitradurga",
      "name": "Chitradurga",
      "key": "city_chitradurga_v2",
      "seo_city_key": "India|Chitradurga",
      "customer_city": "city_chitradurga_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Chitradurga",
        "chitradurga",
        "Chitradurga"
      ],
      "subcities": [
        "chitradurga"
      ],
      "city_address_hint": "69GX+26M, Nehru Nagar, Chitradurga, Karnataka 577501, India",
      "url_name": "chitradurga",
      "country_name": "India",
      "postal_code": "577501",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 14.2250932,
        "long": 76.3980464,
        "details": "69GX+26M, Nehru Nagar, Chitradurga, Karnataka 577501, India",
        "google_place_id": "ChIJ2bvHTPh0ujsRnuKzsqs7Tyg"
      },
      "bounds": [
        13.735896,
        76.056795,
        14.516157,
        76.976818
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Latur",
      "name": "Latur",
      "key": "city_latur_v2",
      "seo_city_key": "India|Latur",
      "customer_city": "city_latur_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Latur",
        "latur",
        "Latur"
      ],
      "subcities": [
        "latur"
      ],
      "city_address_hint": "R-6/569, Chainsukh Rd, Vishal Nagar (East), Latur, Maharashtra 413531, India",
      "url_name": "Latur",
      "country_name": "India",
      "postal_code": "413531",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 18.4087934,
        "long": 76.5603828,
        "details": "R-6/569, Chainsukh Rd, Vishal Nagar (East), Latur, Maharashtra 413531, India",
        "google_place_id": "ChIJKc0ycb2DzzsRPtpIWKybYoM"
      },
      "bounds": [
        17.917024,
        76.373405,
        18.603136,
        77.173204
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Mirzapur",
      "name": "Mirzapur",
      "key": "city_mirzapur_v2",
      "seo_city_key": "India|Mirzapur",
      "customer_city": "city_mirzapur_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Mirzapur"
      ],
      "subcities": [],
      "city_address_hint": "4HR9+XR7, Dankinganj, Mirzapur, Uttar Pradesh 231001",
      "url_name": "Mirzapur",
      "country_name": "India",
      "postal_code": "231001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.70817,
        "long": 92.7211179,
        "details": "4HR9+XR7, Dankinganj, Mirzapur, Uttar Pradesh 231001",
        "google_place_id": "ChIJxVYP_Dq-iDARSdQXYYX4Og4"
      },
      "bounds": [
        24.872219,
        82.346272,
        25.195583,
        83.050378
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Palghar",
      "name": "Palghar",
      "key": "city_palghar_v2",
      "seo_city_key": "India|Palghar",
      "customer_city": "city_palghar_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Palghar",
        "palghar",
        "Palghar"
      ],
      "subcities": [
        "PALGHAR"
      ],
      "city_address_hint": "MQW9+MXM, Mahim Rd, Punit Nagar, Vishnu Nagar, Palghar, Maharashtra 401404, India",
      "url_name": "Palghar",
      "country_name": "India",
      "postal_code": "401404",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 19.6967136,
        "long": 72.769885,
        "details": "MQW9+MXM, Mahim Rd, Punit Nagar, Vishnu Nagar, Palghar, Maharashtra 401404, India",
        "google_place_id": "ChIJd8Hdo94c5zsRJB2WKTaRK9s"
      },
      "bounds": [
        19.671471,
        72.582336,
        20.121253,
        73.132424
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "etawah",
      "name": "Etawah",
      "key": "city_etawah_v2",
      "seo_city_key": "India|Etawah",
      "customer_city": "city_etawah_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Etawah",
        "etawah",
        "Etawah"
      ],
      "subcities": [
        "etawah"
      ],
      "city_address_hint": "76593, near Aryawart Bank, Kashiram Colony, Chogurjee Nagar, Etawah, Uttar Pradesh 206130, India",
      "url_name": "etawah",
      "country_name": "India",
      "postal_code": "206130",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 26.7829103,
        "long": 79.027659,
        "details": "76593, near Aryawart Bank, Kashiram Colony, Chogurjee Nagar, Etawah, Uttar Pradesh 206130, India",
        "google_place_id": "ChIJGWLPhNjfdTkRxQT8TDM2oWo"
      },
      "bounds": [
        26.551805,
        78.863095,
        27.03157,
        79.448012
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "north goa",
      "name": "North Goa",
      "key": "city_north_goa_v2",
      "seo_city_key": "India|North Goa",
      "customer_city": "city_north_goa_v2",
      "state": "Goa",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "North Goa",
        "north goa",
        "North Goa"
      ],
      "subcities": [
        "north goa"
      ],
      "city_address_hint": "GX8M+G6C Rain water harvesting plant, Bharath kumar, Betgi, Goa 403107, India",
      "url_name": "north goa",
      "country_name": "India",
      "postal_code": "403107",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 15.5163112,
        "long": 73.98300290000002,
        "details": "GX8M+G6C Rain water harvesting plant, Bharath kumar, Betgi, Goa 403107, India",
        "google_place_id": "ChIJMaD6Uu3AvzsR0E3VfowKzRs"
      },
      "bounds": [
        15.36783,
        73.561595,
        15.901418,
        74.167296
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "hisar",
      "name": "Hisar",
      "key": "city_hisar_v2",
      "seo_city_key": "India|Hisar",
      "customer_city": "city_hisar_v2",
      "state": "Haryana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Hisar",
        "hisar",
        "Hisar"
      ],
      "subcities": [
        "hisar"
      ],
      "city_address_hint": "4PXC+MMC Jindal tower, Malik Chowk, Old Courts Commercial Complex, Lajpat Nagar, Hisar, Haryana 125001, India",
      "url_name": "hisar",
      "country_name": "India",
      "postal_code": "125001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 29.1491875,
        "long": 75.7216527,
        "details": "4PXC+MMC Jindal tower, Malik Chowk, Old Courts Commercial Complex, Lajpat Nagar, Hisar, Haryana 125001, India",
        "google_place_id": "ChIJNwwdAdgyEjkReBGvBfENPx0"
      },
      "bounds": [
        28.548792,
        75.361061,
        29.640022,
        76.416606
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "solapur",
      "name": "Solapur",
      "key": "city_solapur_v2",
      "seo_city_key": "India|Solapur",
      "customer_city": "city_solapur_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Solapur",
        "solapur",
        "Solapur"
      ],
      "subcities": [
        "solapur"
      ],
      "city_address_hint": "Tilak Chowk, Sangameshwar Public School, 748/4, Vijapur Rd, Old Employment Chowk, Solapur, Maharashtra 413001, India",
      "url_name": "solapur",
      "country_name": "India",
      "postal_code": "413001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 17.660089,
        "long": 75.906051,
        "details": "Tilak Chowk, Sangameshwar Public School, 748/4, Vijapur Rd, Old Employment Chowk, Solapur, Maharashtra 413001, India",
        "google_place_id": "ChIJa3glVnHaxTsREk3xcJj3ppI"
      },
      "bounds": [
        17.296273,
        74.696902,
        18.501945,
        76.311551
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "satara",
      "name": "Satara",
      "key": "city_satara_v2",
      "seo_city_key": "India|Satara",
      "customer_city": "city_satara_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Satara",
        "satara",
        "Satara"
      ],
      "subcities": [
        "satara"
      ],
      "city_address_hint": "HG89+X7R, Devarayamjal, Secunderabad, Telangana 500078, India",
      "url_name": "satara",
      "country_name": "India",
      "postal_code": "415001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 17.568849,
        "long": 78.51815,
        "details": "HG89+X7R, Devarayamjal, Secunderabad, Telangana 500078, India",
        "google_place_id": "ChIJo-lWVwCFyzsRH4pGKJHaD_I"
      },
      "bounds": [
        17.193713,
        73.717361,
        18.163876,
        74.453058
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Solan",
      "name": "Solan",
      "key": "city_solan_v2",
      "seo_city_key": "India|Solan",
      "customer_city": "city_solan_v2",
      "state": "Himanchal Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Solan"
      ],
      "subcities": [],
      "city_address_hint": "Head post office, Ram Bazar, Solan, Himachal Pradesh 173212",
      "url_name": "Solan",
      "country_name": "India",
      "postal_code": "173212",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.70817,
        "long": 92.7211179,
        "details": "Head post office, Ram Bazar, Solan, Himachal Pradesh 173212",
        "google_place_id": "ChIJxVYP_Dq-iDARSdQXYYX4Og4"
      },
      "bounds": [
        30.823642,
        76.466869,
        31.23816,
        77.178186
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "kolkata",
      "name": "Kolkata",
      "key": "city_kolkata_v2",
      "seo_city_key": "india|kolkata",
      "customer_city": "city_kolkata_v2",
      "state": "West Bengal",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "kolkata",
        "calcutta",
        "belgachia",
        "howrah",
        "hooghly"
      ],
      "subcities": [
        "Kolkata",
        "kolkata",
        "Howrah"
      ],
      "city_address_hint": "Old Ballygunge Road, Kolkata",
      "url_name": "kolkata",
      "country_name": "India",
      "postal_code": "700017",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 22.5279046,
        "long": 88.3624861,
        "details": "Old Ballygunge Road, Kolkata",
        "google_place_id": "ChIJSw1kIfWEXjkRa5miqZfuU2g"
      },
      "bounds": [
        21.602248,
        87.138824,
        23.010552,
        88.968328
      ],
      "offices": [
        {
          "name": "Kolkata",
          "is_live": true,
          "address": "Urban Company Limited, Asyst Park, 1st and 2nd floor, GN-37/1, Salt Lake Sector 5, WABEL More, Kolkata 700091",
          "subcities": [
            "Kolkata"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 22.5721111,
            "long": 88.4309444
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jaipur",
      "name": "Jaipur",
      "key": "city_jaipur_v2",
      "seo_city_key": "india|jaipur",
      "customer_city": "city_jaipur_v2",
      "state": "Rajasthan",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "jaipur"
      ],
      "subcities": [
        "Jaipur",
        "jaipur"
      ],
      "city_address_hint": "Ashok Nagar, Jaipur",
      "url_name": "jaipur",
      "country_name": "India",
      "postal_code": "302005",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 26.91617,
        "long": 75.77752,
        "details": "Ashok Nagar, Jaipur",
        "google_place_id": "ChIJwZvVDqq2bTkRQKrJ2WRMAJQ"
      },
      "bounds": [
        26.59111,
        75.465046,
        27.071879,
        76.064951
      ],
      "offices": [
        {
          "name": "Jaipur",
          "is_live": true,
          "address": "Urban Company Limited, C-123, First floor, Janpath, Lalkothi (Opposite Jyoti Nagar Police station), Jaipur (302005)",
          "subcities": [
            "Jaipur"
          ],
          "office_type": [
            "corporate",
            "training",
            "business",
            "support"
          ],
          "location_mapping": {
            "lat": 26.891634,
            "long": 75.794923
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Mancherial",
      "name": "Mancherial",
      "key": "city_mancherial_v2",
      "seo_city_key": "India|Mancherial",
      "customer_city": "city_mancherial_v2",
      "state": "Telangana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [],
      "subcities": [
        "Mancherial"
      ],
      "city_address_hint": "Indra Nagar, Janmabhoomi Nagar, Mancherial, Telangana ",
      "url_name": "Mancherial",
      "country_name": "India",
      "postal_code": "504208",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.70817,
        "long": 92.7211179,
        "details": "Indra Nagar, Janmabhoomi Nagar, Mancherial, Telangana ",
        "google_place_id": "ChIJxVYP_Dq-iDARSdQXYYX4Og4"
      },
      "bounds": [
        18.575437,
        78.862576,
        19.307409,
        80.118402
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "alwar",
      "name": "Alwar+rewari",
      "key": "city_alwar_v2",
      "seo_city_key": "india|alwar",
      "customer_city": "city_alwar_v2",
      "state": "Rajasthan",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "alwar",
        "Alwar"
      ],
      "subcities": [
        "alwar"
      ],
      "city_address_hint": "Hanuman Circle Park, Alwar",
      "url_name": "alwar",
      "country_name": "India",
      "postal_code": "301001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 27.55488,
        "long": 76.640655,
        "details": "Hanuman Circle Park, Alwar",
        "google_place_id": "ChIJR7PVA2GbcjkRnhDhuDwwjMg"
      },
      "bounds": [
        27.073092,
        76.1587,
        28.457126,
        76.836414
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jalgaon",
      "name": "Jalgaon",
      "key": "city_jalgaon_v2",
      "seo_city_key": "India|Jalgaon",
      "customer_city": "city_jalgaon_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Jalgaon",
        "jalgaon",
        "Jalgaon"
      ],
      "subcities": [
        "jalgaon"
      ],
      "city_address_hint": "2, Pachora - Jalgaon Rd, Pratap Nagar, Jalgaon, Maharashtra 425003, India",
      "url_name": "jalgaon",
      "country_name": "India",
      "postal_code": "425001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 21.0076578,
        "long": 75.5626039,
        "details": "2, Pachora - Jalgaon Rd, Pratap Nagar, Jalgaon, Maharashtra 425003, India",
        "google_place_id": "ChIJD7nqoaQP2TsRPAr_G9J79jc"
      },
      "bounds": [
        20.553563,
        74.998812,
        21.348622,
        76.131091
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "aligarh",
      "name": "Aligarh",
      "key": "city_aligarh_v2",
      "seo_city_key": "India|Aligarh",
      "customer_city": "city_aligarh_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Aligarh",
        "aligarh",
        "Aligarh"
      ],
      "subcities": [
        "aligarh"
      ],
      "city_address_hint": "I145, Begpur, Kasimpur Power House Colony, Aligarh, Uttar Pradesh 202001, India",
      "url_name": "aligarh",
      "country_name": "India",
      "postal_code": "202001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 27.8973944,
        "long": 78.0880129,
        "details": "I145, Begpur, Kasimpur Power House Colony, Aligarh, Uttar Pradesh 202001, India",
        "google_place_id": "ChIJi5xFhoakdDkREzYybSdn2ZU"
      },
      "bounds": [
        27.364088,
        76.984946,
        28.156459,
        78.54971
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Maldah",
      "name": "Maldah",
      "key": "city_maldah_v2",
      "seo_city_key": "India|Maldah",
      "customer_city": "city_maldah_v2",
      "state": "West Bengal",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "maldah"
      ],
      "subcities": [
        "maldah"
      ],
      "city_address_hint": "Maldah, West Bengal, 732101",
      "url_name": "Maldah",
      "country_name": "India",
      "postal_code": "732101",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.2381216,
        "long": 87.64535920000002,
        "details": "Maldah, West Bengal, 732101",
        "google_place_id": "ChIJbWuvxb6Y-jkRo5_UmpP6iVA"
      },
      "bounds": [
        24.867204,
        87.783036,
        25.42475,
        88.511266
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "samastipur",
      "name": "Samastipur",
      "key": "city_samastipur_v2",
      "seo_city_key": "India|Samastipur",
      "customer_city": "city_samastipur_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Samastipur",
        "samastipur",
        "Samastipur"
      ],
      "subcities": [
        "samastipur"
      ],
      "city_address_hint": "11, Sharda Nagar, Samastipur, Bihar 848101, India",
      "url_name": "samastipur",
      "country_name": "India",
      "postal_code": "848101",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.8560271,
        "long": 85.7868233,
        "details": "11, Sharda Nagar, Samastipur, Bihar 848101, India",
        "google_place_id": "ChIJ3b1C-5CQ7TkRvTt0hbXbvGc"
      },
      "bounds": [
        25.638324,
        85.656457,
        26.542661,
        86.270097
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ganjam",
      "name": "Ganjam",
      "key": "city_ganjam_v2",
      "seo_city_key": "India|Ganjam",
      "customer_city": "city_ganjam_v2",
      "state": "Odisha",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ganjam",
        "ganjam",
        "Ganjam"
      ],
      "subcities": [
        "ganjam"
      ],
      "city_address_hint": "93P2+RWW, Ganjam, Odisha 761026, India",
      "url_name": "ganjam",
      "country_name": "India",
      "postal_code": "761120",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 19.3871214,
        "long": 85.05233559999999,
        "details": "93P2+RWW, Ganjam, Odisha 761026, India",
        "google_place_id": "ChIJ28-RR8j7FzoRxhTp5xWaTmY"
      },
      "bounds": [
        19.170269,
        84.339458,
        20.084262,
        85.364021
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "muzaffarpur",
      "name": "Muzaffarpur",
      "key": "city_muzaffarpur_v2",
      "seo_city_key": "India|Muzaffarpur",
      "customer_city": "city_muzaffarpur_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Muzaffarpur",
        "muzaffarpur",
        "Muzaffarpur"
      ],
      "subcities": [
        "muzaffarpur"
      ],
      "city_address_hint": "00000 Tamulia, Mahammadpur Kazi, Pokhraira, Muzaffarpur, Bihar 842001, India",
      "url_name": "muzaffarpur",
      "country_name": "India",
      "postal_code": "842001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 26.1196607,
        "long": 85.390982,
        "details": "00000 Tamulia, Mahammadpur Kazi, Pokhraira, Muzaffarpur, Bihar 842001, India",
        "google_place_id": "ChIJKVUXo-gQ7TkRnXUPaBnZwgc"
      },
      "bounds": [
        25.656854,
        85.05185,
        26.852101,
        85.653533
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Dakshina Kannada",
      "name": "Dakshina Kannada",
      "key": "city_dakshina_kannada_v2",
      "seo_city_key": "India|Dakshina Kannada",
      "customer_city": "city_dakshina_kannada_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Dakshina Kannada",
        "dakshina kannada",
        "Dakshina Kannada"
      ],
      "subcities": [
        "dakshin kannada"
      ],
      "city_address_hint": "R6VX+G56, Uppinangady, Karnataka 574241, India",
      "url_name": "Dakshina Kannada",
      "country_name": "India",
      "postal_code": "574241",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 12.8437814,
        "long": 75.2479061,
        "details": "R6VX+G56, Uppinangady, Karnataka 574241, India",
        "google_place_id": "ChIJvxb9K01aozsRXPsrJAvQjS8"
      },
      "bounds": [
        12.783051,
        74.74612,
        13.13301,
        75.061587
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "bhandara",
      "name": "Bhandara",
      "key": "city_bhandara_v2",
      "seo_city_key": "India|Bhandara",
      "customer_city": "city_bhandara_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Bhandara",
        "bhandara",
        "Bhandara"
      ],
      "subcities": [
        "bhandara"
      ],
      "city_address_hint": "Ring Rd, Shivaji Ward, Bhandara, Maharashtra 441904, India",
      "url_name": "bhandara",
      "country_name": "India",
      "postal_code": "441904",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 21.177658,
        "long": 79.6570127,
        "details": "Ring Rd, Shivaji Ward, Bhandara, Maharashtra 441904, India",
        "google_place_id": "ChIJNZxip6s4KzoRF4-uGIyxW-s"
      },
      "bounds": [
        20.937713,
        79.539611,
        21.510494,
        79.916783
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "karnal",
      "name": "Karnal",
      "key": "city_karnal_v2",
      "seo_city_key": "india|panipat",
      "customer_city": "city_karnal_v2",
      "state": "Haryana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "karnal",
        "Karnal"
      ],
      "subcities": [
        "karnal"
      ],
      "city_address_hint": "Karan Taal Park, Karnal",
      "url_name": "karnal",
      "country_name": "India",
      "postal_code": "132001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 29.68692,
        "long": 76.98641,
        "details": "Karan Taal Park, Karnal",
        "google_place_id": "ChIJhap4lONxDjkRKIatmdUsqdY"
      },
      "bounds": [
        29.478246,
        77.108049,
        29.495572,
        77.127617
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "suryapet",
      "name": "Suryapet",
      "key": "city_suryapet_v2",
      "seo_city_key": "India|Suryapet",
      "customer_city": "city_suryapet_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "suryapet"
      ],
      "subcities": [
        "suryapet"
      ],
      "city_address_hint": "4JR7+85G, Thallagadda, Suryapet, Telangana 508213, India",
      "url_name": "suryapet",
      "country_name": "India",
      "postal_code": "508213",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 17.141312,
        "long": 79.612793,
        "details": "4JR7+85G, Thallagadda, Suryapet, Telangana 508213, India",
        "google_place_id": "ChIJb52xOrbbNDoROZAoFjmpRmo"
      },
      "bounds": [
        16.745553,
        79.047309,
        17.7034,
        80.01553
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jaunpur",
      "name": "Jaunpur",
      "key": "city_jaunpur_v2",
      "seo_city_key": "India|Jaunpur",
      "customer_city": "city_jaunpur_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Jaunpur",
        "jaunpur",
        "Jaunpur"
      ],
      "subcities": [
        "jaunpur"
      ],
      "city_address_hint": "PMWM+HF8, Olandganj, Jaunpur, Uttar Pradesh 222002, India",
      "url_name": "jaunpur",
      "country_name": "India",
      "postal_code": "222002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.7464145,
        "long": 82.68370329999999,
        "details": "PMWM+HF8, Olandganj, Jaunpur, Uttar Pradesh 222002, India",
        "google_place_id": "ChIJFUeZkyw6kDkRInPJDfGp-QA"
      },
      "bounds": [
        25.499295,
        82.364281,
        26.006243,
        82.854975
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Pratapgarh",
      "name": "Pratapgarh",
      "key": "city_pratapgarh_v2",
      "seo_city_key": "India|Pratapgarh",
      "customer_city": "city_pratapgarh_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Pratapgarh"
      ],
      "subcities": [],
      "city_address_hint": "WXCQ+WRQ, Bela Pratapgarh, Uttar Pradesh 230001",
      "url_name": "Pratapgarh",
      "country_name": "India",
      "postal_code": "230001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.70817,
        "long": 92.7211179,
        "details": "WXCQ+WRQ, Bela Pratapgarh, Uttar Pradesh 230001",
        "google_place_id": "ChIJxVYP_Dq-iDARSdQXYYX4Og4"
      },
      "bounds": [
        25.673201,
        81.574912,
        25.6828,
        82.24975
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "prayagraj",
      "name": "Prayagraj",
      "key": "city_prayagraj_v2",
      "seo_city_key": "india|prayagraj",
      "customer_city": "city_prayagraj_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "prayagraj",
        "allahabad",
        "ilahabad"
      ],
      "subcities": [
        "prayagraj"
      ],
      "city_address_hint": "Prayagraj Fort, Allahabad",
      "url_name": "prayagraj",
      "country_name": "India",
      "postal_code": "211003",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.4021974,
        "long": 81.6614982,
        "details": "Prayagraj Fort, Allahabad",
        "google_place_id": "ChIJu0-pK65KhTkRUgI4wRKJMno"
      },
      "bounds": [
        25.097211,
        81.573453,
        25.669182,
        82.21478
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Yavatmal",
      "name": "Yavatmal",
      "key": "city_yavatmal_v2",
      "seo_city_key": "India|Yavatmal",
      "customer_city": "city_yavatmal_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Yavatmal",
        "yavatmal",
        "Yavatmal"
      ],
      "subcities": [
        "yavatmal"
      ],
      "city_address_hint": "17/1, Vaishnavi Nagar, Yavatmal, Maharashtra 445001, India",
      "url_name": "Yavatmal",
      "country_name": "India",
      "postal_code": "445001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 20.3899385,
        "long": 78.1306846,
        "details": "17/1, Vaishnavi Nagar, Yavatmal, Maharashtra 445001, India",
        "google_place_id": "ChIJ3U60i8zo0zsR4L7sQeqtd0g"
      },
      "bounds": [
        19.508182,
        77.417822,
        20.527754,
        78.733435
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "nashik",
      "name": "Nashik",
      "key": "city_nashik_v2",
      "seo_city_key": "india|nashik",
      "customer_city": "city_nashik_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Nashik",
        "nashik"
      ],
      "subcities": [
        "Nashik",
        "nashik"
      ],
      "city_address_hint": "2QGR+GF Nashik, Maharashtra, India",
      "url_name": "nashik",
      "country_name": "India",
      "postal_code": "422001",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 20.026361,
        "long": 73.791229,
        "details": "2QGR+GF Nashik, Maharashtra, India",
        "google_place_id": "GhIJIeKLm78GNEARLwlhf6NyUkA"
      },
      "bounds": [
        18.797202,
        73.595864,
        20.718161,
        74.970104
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "aurangabad",
      "name": "Aurangabad",
      "key": "city_aurangabad_v2",
      "seo_city_key": "india|aurangabad",
      "customer_city": "city_aurangabad_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "aurangabad",
        "Aurangabad"
      ],
      "subcities": [
        "aurangabad"
      ],
      "city_address_hint": "Kranti Chowk Police Station, Aurangabad",
      "url_name": "aurangabad",
      "country_name": "India",
      "postal_code": "431003",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 19.80904,
        "long": 75.24408,
        "details": "Kranti Chowk Police Station, Aurangabad",
        "google_place_id": "ChIJKyQSU2mY2zsR5jVtghEwn7I"
      },
      "bounds": [
        19.433912,
        74.979721,
        20.431853,
        75.689717
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "srikakulam",
      "name": "Srikakulam",
      "key": "city_srikakulam_v2",
      "seo_city_key": "India|Srikakulam",
      "customer_city": "city_srikakulam_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Srikakulam",
        "srikakulam",
        "Srikakulam"
      ],
      "subcities": [
        "srikakulam"
      ],
      "city_address_hint": "7VVV+XG7, Seven Rd Junction Area, New Colony, Srikakulam, Andhra Pradesh 532001, India",
      "url_name": "srikakulam",
      "country_name": "India",
      "postal_code": "532001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 18.2949165,
        "long": 83.89380179999999,
        "details": "7VVV+XG7, Seven Rd Junction Area, New Colony, Srikakulam, Andhra Pradesh 532001, India",
        "google_place_id": "ChIJIXNz8Q4VPDoRt1OJiRHPRQo"
      },
      "bounds": [
        18.105167,
        83.500857,
        19.153415,
        84.823938
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "udupi",
      "name": "Udupi",
      "key": "city_udupi_v2",
      "seo_city_key": "India|Udupi",
      "customer_city": "city_udupi_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Udupi",
        "udupi",
        "Udupi"
      ],
      "subcities": [
        "udupi"
      ],
      "city_address_hint": "2-50, Saraswati Nagar, Udupi, Karnataka 576101, India",
      "url_name": "udupi",
      "country_name": "India",
      "postal_code": "576101",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 13.3408807,
        "long": 74.7421427,
        "details": "2-50, Saraswati Nagar, Udupi, Karnataka 576101, India",
        "google_place_id": "ChIJz0GPk2m7vDsRQwGFMeSZzMw"
      },
      "bounds": [
        13.170088,
        74.699049,
        13.624925,
        75.356123
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "cuttack",
      "name": "Cuttack",
      "key": "city_cuttack_v2",
      "seo_city_key": "india|cuttack",
      "customer_city": "city_cuttack_v2",
      "state": "Orissa",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "cuttack",
        "Cuttack"
      ],
      "subcities": [
        "cuttack"
      ],
      "city_address_hint": "Dipti Plaza, Cuttack",
      "url_name": "cuttack",
      "country_name": "India",
      "postal_code": "753001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 20.474915,
        "long": 85.873641,
        "details": "Dipti Plaza, Cuttack",
        "google_place_id": "ChIJFbWB53USGToRtxUdbS_o21Y"
      },
      "bounds": [
        20.399,
        85.427586,
        20.565977,
        86.306267
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ramanagara",
      "name": "Ramanagara",
      "key": "city_ramanagara_v2",
      "seo_city_key": "India|Ramanagara",
      "customer_city": "city_ramanagara_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ramanagara",
        "ramanagara",
        "Ramanagara"
      ],
      "subcities": [
        "Ramanagara"
      ],
      "city_address_hint": "6360979133 Kumudan Mohalla, Mandipet, Agrahar, Ramanagara, Karnataka 562159, India",
      "url_name": "ramanagara",
      "country_name": "India",
      "postal_code": "562159",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 12.7208614,
        "long": 77.27989629999999,
        "details": "6360979133 Kumudan Mohalla, Mandipet, Agrahar, Ramanagara, Karnataka 562159, India",
        "google_place_id": "ChIJJeRmOthNrjsRCzp0Rh0guMw"
      },
      "bounds": [
        12.432247,
        76.633662,
        12.995491,
        77.358713
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "patiala",
      "name": "Patiala",
      "key": "city_patiala_v2",
      "seo_city_key": "India|Patiala",
      "customer_city": "city_patiala_v2",
      "state": "Punjab",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Patiala",
        "patiala",
        "Patiala"
      ],
      "subcities": [
        "patiala"
      ],
      "city_address_hint": "89QP+WQ6, Green View Colony, Patiala, Punjab 147001, India",
      "url_name": "patiala",
      "country_name": "India",
      "postal_code": "147001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 30.3397809,
        "long": 76.3868797,
        "details": "89QP+WQ6, Green View Colony, Patiala, Punjab 147001, India",
        "google_place_id": "ChIJ3xMzWpMoEDkRf7yQO61WvNU"
      },
      "bounds": [
        30.148838,
        76.12135,
        30.546496,
        76.608868
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "riyadh",
      "name": "Riyadh",
      "key": "city_riyadh_v2",
      "seo_city_key": "saudi_arabia|riyadh",
      "customer_city": "city_riyadh_v2",
      "state": "Riyadh state",
      "country_key": "KSA",
      "country_id": "KSA",
      "regex": [
        "riyadh",
        "??????",
        "az zulfi",
        "al mubarraz",
        "al kharj",
        "afif",
        "al musaybir",
        "al hazm",
        "salam"
      ],
      "subcities": [
        "Riyadh",
        "riyadh",
        "??????"
      ],
      "city_address_hint": "Kingdom Centre, Al Olaya",
      "url_name": "riyadh",
      "country_name": "KSA",
      "postal_code": "12214",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 24.71226,
        "long": 46.674214,
        "details": "Kingdom Centre, Al Olaya",
        "google_place_id": "GhIJvD_eq1a2OEARhcFGo0xWR0A"
      },
      "bounds": [
        24.230601,
        46.152973,
        25.168818,
        47.070332
      ],
      "offices": [
        {
          "name": "Riyadh Office",
          "is_live": true,
          "address": "2488, 8653, 3rd Floor, Le Cygne Commercial Center, Next to Reem Residnecy, Kaab Bin Malik, Olaya, Riyadh 12611 MMFV+RC Al Olaya, Riyadh",
          "subcities": [
            "Riyadh"
          ],
          "office_type": [
            "business"
          ],
          "location_mapping": {
            "lat": 24.674503,
            "long": 46.6935984
          }
        }
      ],
      "timezone": "Asia/Riyadh"
    },
    {
      "is_live": true,
      "regex_key": "jeddah",
      "name": "Jeddah",
      "key": "city_jeddah_v2",
      "seo_city_key": "saudi_arabia|jeddah",
      "customer_city": "city_jeddah_v2",
      "state": "Jeddah state",
      "country_key": "KSA",
      "country_id": "KSA",
      "regex": [
        "jeddah",
        "جدة"
      ],
      "subcities": [
        "Jeddah",
        "jeddah",
        "جدة"
      ],
      "city_address_hint": "World of Saving, Prince Saud Al Faisal",
      "url_name": "jeddah",
      "country_name": "KSA",
      "postal_code": "23444",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 21.571111,
        "long": 39.187716,
        "details": "World of Saving, Prince Saud Al Faisal",
        "google_place_id": "ChIJnc1CWFDQwxURN0vSStLYS5M"
      },
      "bounds": [
        21.011638,
        38.869166,
        23.008982,
        39.518333
      ],
      "offices": [],
      "timezone": "Asia/Riyadh"
    },
    {
      "is_live": true,
      "regex_key": "Dammam",
      "name": "Dammam",
      "key": "city_dammam_v2",
      "seo_city_key": "Saudi Arabia|Dammam",
      "customer_city": "city_dammam_v2",
      "state": "Eastern Province",
      "country_key": "KSA",
      "country_id": "KSA",
      "regex": [
        "Dammam",
        "dammam",
        "Dammam"
      ],
      "subcities": [],
      "city_address_hint": "C3CQ+7GF, Al Itisalat, Dammam 32257, Saudi Arabia",
      "url_name": "Dammam",
      "country_name": "KSA",
      "postal_code": "32253",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 26.4206828,
        "long": 50.0887943,
        "details": "C3CQ+7GF, Al Itisalat, Dammam 32257, Saudi Arabia",
        "google_place_id": "ChIJAzRrJzIdNj4RdlZeeuwB2e8"
      },
      "bounds": [
        26.029303,
        49.746074,
        26.600652,
        50.239007
      ],
      "offices": [],
      "timezone": "Asia/Riyadh"
    },
    {
      "is_live": true,
      "regex_key": "buraydah",
      "name": "Buraydah",
      "key": "city_buraydah_v2",
      "seo_city_key": "Saudi Arabia|Buraydah",
      "customer_city": "city_buraydah_v2",
      "state": "Al Qassim",
      "country_key": "KSA",
      "country_id": "KSA",
      "regex": [
        "Buraydah",
        "buraydah",
        "Buraydah"
      ],
      "subcities": [
        "buraydah"
      ],
      "city_address_hint": "9X5J+MPV, Buraydah 52367, Saudi Arabia",
      "url_name": "buraydah",
      "country_name": "KSA",
      "postal_code": "52367",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 26.3592309,
        "long": 43.98181200000001,
        "details": "9X5J+MPV, Buraydah 52367, Saudi Arabia",
        "google_place_id": "ChIJd3uBg2ZYfxURYYpZ497BU1g"
      },
      "bounds": [
        25.621561,
        43.107262,
        26.718014,
        44.447079
      ],
      "offices": [],
      "timezone": "Asia/Riyadh"
    },
    {
      "is_live": true,
      "regex_key": "guwahati",
      "name": "Guwahati",
      "key": "city_guwahati_v2",
      "seo_city_key": "india|guwahati",
      "customer_city": "city_guwahati_v2",
      "state": "Assam",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "guwahati"
      ],
      "subcities": [
        "guwahati",
        "Guwahati"
      ],
      "city_address_hint": "6M3J+Q3W, Amingaon, Guwahati, Silamahekhaity, Assam 781039, India",
      "url_name": "guwahati",
      "country_name": "India",
      "postal_code": "781006",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 26.203589,
        "long": 91.679864,
        "details": "6M3J+Q3W, Amingaon, Guwahati, Silamahekhaity, Assam 781039, India",
        "google_place_id": "ChIJASmr57NaWjcRwXlPDyeo478"
      },
      "bounds": [
        25.949542,
        91.271096,
        26.494292,
        91.88071
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "hassan",
      "name": "Hassan",
      "key": "city_hassan_v2",
      "seo_city_key": "India|Hassan",
      "customer_city": "city_hassan_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Hassan",
        "hassan",
        "Hassan"
      ],
      "subcities": [
        "hassan"
      ],
      "city_address_hint": "83c, Bangalore - Mangalore Rd, Ammeer Mohalla, Hassan, Karnataka 573201, India",
      "url_name": "hassan",
      "country_name": "India",
      "postal_code": "573201",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 13.0033234,
        "long": 76.1003894,
        "details": "83c, Bangalore - Mangalore Rd, Ammeer Mohalla, Hassan, Karnataka 573201, India",
        "google_place_id": "ChIJRyekCyNIpTsRP_Wht7ZP27A"
      },
      "bounds": [
        12.898451,
        75.97003,
        13.465371,
        76.310724
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "sikar",
      "name": "Sikar",
      "key": "city_sikar_v2",
      "seo_city_key": "India|Sikar",
      "customer_city": "city_sikar_v2",
      "state": "Rajasthan",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Sikar",
        "sikar",
        "Sikar"
      ],
      "subcities": [
        "SIKAR"
      ],
      "city_address_hint": "Sawaliya Circle (Bypass Sikhar), Subhash Chowk, Sikar, Rajasthan 332001, India",
      "url_name": "sikar",
      "country_name": "India",
      "postal_code": "332001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 27.6093912,
        "long": 75.1397935,
        "details": "Sawaliya Circle (Bypass Sikhar), Subhash Chowk, Sikar, Rajasthan 332001, India",
        "google_place_id": "ChIJK0c0I7ikbDkRVfNrOs5cSH8"
      },
      "bounds": [
        27.219909,
        74.850883,
        28.494868,
        76.034171
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "visakhapatnam",
      "name": "Visakhapatnam",
      "key": "city_vishakapatnam_v2",
      "seo_city_key": "india|visakhapatnam",
      "customer_city": "city_vishakapatnam_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "visakhapatnam"
      ],
      "subcities": [
        "Visakhapatnam",
        "visakhapatnam"
      ],
      "city_address_hint": "Kailasapuram, Visakhapatnam",
      "url_name": "visakhapatnam",
      "country_name": "India",
      "postal_code": "530016",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 17.73931,
        "long": 83.28939,
        "details": "Kailasapuram, Visakhapatnam",
        "google_place_id": "ChIJLT1ujypDOToRtHNiUeVQRIo"
      },
      "bounds": [
        17.511529,
        82.902444,
        18.049486,
        83.48025
      ],
      "offices": [
        {
          "name": "Visakhapatnam",
          "is_live": true,
          "address": "3rd floor, Front Side, Grand Palace, Dwarka Nagar, Vishakapatnam",
          "subcities": [
            "Visakhapatnam"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 17.72608,
            "long": 83.305394
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "chikkaballapur",
      "name": "Chikkaballapur",
      "key": "city_chikkaballapur_v2",
      "seo_city_key": "India|Chikkaballapur",
      "customer_city": "city_chikkaballapur_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Chikkaballapur",
        "chikkaballapur",
        "Chikkaballapur"
      ],
      "subcities": [
        "chikkaballapur"
      ],
      "city_address_hint": "CPPJ+5JV, Chikkaballapur, Karnataka 562101, India",
      "url_name": "chikkaballapur",
      "country_name": "India",
      "postal_code": "562101",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 13.4354985,
        "long": 77.7315344,
        "details": "CPPJ+5JV, Chikkaballapur, Karnataka 562101, India",
        "google_place_id": "ChIJQW-c82DlsTsRKsrp6tUI33E"
      },
      "bounds": [
        13.391457,
        77.475038,
        13.663168,
        78.187345
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Kolar",
      "name": "Kolar",
      "key": "city_kolar_v2",
      "seo_city_key": "India|Kolar",
      "customer_city": "city_kolar_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Kolar",
        "kolar",
        "Kolar"
      ],
      "subcities": [
        "kolar"
      ],
      "city_address_hint": "Antharagange Main Rd, Kuvempu Nagar, Kolar, Karnataka 563101, India",
      "url_name": "Kolar",
      "country_name": "India",
      "postal_code": "563101",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 13.1362143,
        "long": 78.12909859999999,
        "details": "Antharagange Main Rd, Kuvempu Nagar, Kolar, Karnataka 563101, India",
        "google_place_id": "ChIJzayVlYvwrTsR0PP9J1ST70M"
      },
      "bounds": [
        12.847369,
        77.93448,
        13.362356,
        78.518859
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "krishnagiri",
      "name": "Krishnagiri",
      "key": "city_krishnagiri_v2",
      "seo_city_key": "India|Krishnagiri",
      "customer_city": "city_krishnagiri_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Krishnagiri",
        "krishnagiri",
        "Krishnagiri"
      ],
      "subcities": [
        "krishnagiri"
      ],
      "city_address_hint": "G6G7+JXG, Old Pet, Krishnagiri, Tamil Nadu 635001, India",
      "url_name": "krishnagiri",
      "country_name": "India",
      "postal_code": "635001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 12.5265661,
        "long": 78.2149575,
        "details": "G6G7+JXG, Old Pet, Krishnagiri, Tamil Nadu 635001, India",
        "google_place_id": "ChIJQXB4a5M0rDsR2zWYAgfJR4Q"
      },
      "bounds": [
        12.220385,
        77.911484,
        12.676677,
        78.457148
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "coimbatore",
      "name": "Coimbatore",
      "key": "city_coimbatore_v2",
      "seo_city_key": "india|coimbatore",
      "customer_city": "city_coimbatore_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "coimbatore",
        "covai"
      ],
      "subcities": [
        "coimbatore",
        "Coimbatore",
        "Covai",
        "covai"
      ],
      "city_address_hint": "184, Balaji Nagar, New Siddhapudur, Coimbatore, Tamil Nadu 641044, India",
      "url_name": "coimbatore",
      "country_name": "India",
      "postal_code": "641044",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.022391,
        "long": 76.979189,
        "details": "184, Balaji Nagar, New Siddhapudur, Coimbatore, Tamil Nadu 641044, India",
        "google_place_id": "ChIJ22Vi-U5YqDsR3J5HYtBmxVA"
      },
      "bounds": [
        10.530549,
        76.675765,
        11.350934,
        77.109863
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "palakkad district",
      "name": "Palakkad district",
      "key": "city_palakkad_district_v2",
      "seo_city_key": "India|Palakkad district",
      "customer_city": "city_palakkad_district_v2",
      "state": "Kerala",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Palakkad district",
        "palakkad district",
        "Palakkad district"
      ],
      "subcities": [
        "palakkad"
      ],
      "city_address_hint": "XG2X+GG4, Kerala 678591, India",
      "url_name": "palakkad district",
      "country_name": "India",
      "postal_code": "678591",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 10.9512736,
        "long": 76.5488232,
        "details": "XG2X+GG4, Kerala 678591, India",
        "google_place_id": "ChIJWQs2Ju9tqDsRmbA67dugBGc"
      },
      "bounds": [
        10.766182,
        76.321103,
        10.961997,
        76.661716
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "indore",
      "name": "Indore",
      "key": "city_indore_v2",
      "seo_city_key": "india|indore",
      "customer_city": "city_indore_v2",
      "state": "Madhya Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "indore"
      ],
      "subcities": [
        "Indore",
        "indore"
      ],
      "city_address_hint": "63, Maharani Rd, Siyaganj, Indore, Madhya Pradesh 452007, India",
      "url_name": "indore",
      "country_name": "India",
      "postal_code": "452007",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 22.717199,
        "long": 75.865844,
        "details": "63, Maharani Rd, Siyaganj, Indore, Madhya Pradesh 452007, India",
        "google_place_id": "ChIJLczF6BH9YjkR-tvBi10qqDI"
      },
      "bounds": [
        22.420788,
        75.490283,
        22.838043,
        76.085689
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "valsad",
      "name": "Valsad",
      "key": "city_valsad_v2",
      "seo_city_key": "India|Valsad",
      "customer_city": "city_valsad_v2",
      "state": "Gujarat",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Valsad",
        "valsad",
        "Valsad"
      ],
      "subcities": [
        "valsad"
      ],
      "city_address_hint": "142, Gandhidham Road, Shiv Township Colony, West Railway Colony, Mundra Kutch, Valsad, Gujarat 370421, India",
      "url_name": "valsad",
      "country_name": "India",
      "postal_code": "370421",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 20.5992349,
        "long": 72.9342451,
        "details": "142, Gandhidham Road, Shiv Township Colony, West Railway Colony, Mundra Kutch, Valsad, Gujarat 370421, India",
        "google_place_id": "ChIJz6ZJgiDo4DsRE6iVTP0ptvY"
      },
      "bounds": [
        20.124621,
        72.612205,
        21.038894,
        73.413948
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "akola",
      "name": "Akola",
      "key": "city_akola_v2",
      "seo_city_key": "India|Akola",
      "customer_city": "city_akola_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Akola",
        "akola",
        "Akola"
      ],
      "subcities": [
        "akola"
      ],
      "city_address_hint": "P225+37M, Bhandaraj BK, Akola, Maharashtra 444002, India",
      "url_name": "akola",
      "country_name": "India",
      "postal_code": "444002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 20.7002159,
        "long": 77.0081678,
        "details": "P225+37M, Bhandaraj BK, Akola, Maharashtra 444002, India",
        "google_place_id": "ChIJ8V0qw5Ix1zsRU7Im6JEqp88"
      },
      "bounds": [
        20.339448,
        76.752453,
        21.234555,
        77.375157
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "dehradun",
      "name": "Dehradun",
      "key": "city_dehradun_v2",
      "seo_city_key": "india|dehradun",
      "customer_city": "city_dehradun_v2",
      "state": "Uttarakhand",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "dehradun"
      ],
      "subcities": [
        "dehradun"
      ],
      "city_address_hint": "Doon Hospital",
      "url_name": "dehradun",
      "country_name": "India",
      "postal_code": "248001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 30.4712267,
        "long": 77.111402,
        "details": "Doon Hospital",
        "google_place_id": "ChIJr4jIVsMpCTkRmYdRMsBiNUw"
      },
      "bounds": [
        29.678743,
        77.390698,
        30.537084,
        78.360956
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "vadodara",
      "name": "Vadodara",
      "key": "city_vadodara_v2",
      "seo_city_key": "india|vadodra",
      "customer_city": "city_vadodara_v2",
      "state": "Gujrat",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "vadodara"
      ],
      "subcities": [
        "Vadodara",
        "vadodara"
      ],
      "city_address_hint": "Alkapuri, Vadodara",
      "url_name": "vadodara",
      "country_name": "India",
      "postal_code": "390001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 22.31423,
        "long": 73.1752,
        "details": "Alkapuri, Vadodara",
        "google_place_id": "ChIJe2vZ0bDIXzkRgRaolb5LoFg"
      },
      "bounds": [
        22.050485,
        73.016959,
        22.708894,
        73.81879
      ],
      "offices": [
        {
          "name": "Vadodara",
          "is_live": true,
          "address": "2nd floor, 50, Sampatrao Colony, Alkapuri, Vadodara - 390007",
          "subcities": [
            "Vadodara"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 22.309201,
            "long": 73.75448
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "tiruchirappalli",
      "name": "Tiruchirappalli",
      "key": "city_tiruchirappalli_v2",
      "seo_city_key": "india|tiruchirappalli",
      "customer_city": "city_tiruchirappalli_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "tiruchirappalli",
        "Tiruchirappalli"
      ],
      "subcities": [
        "tiruchirappalli"
      ],
      "city_address_hint": "DMart Trichy, Tiruchirappalli",
      "url_name": "tiruchirappalli",
      "country_name": "India",
      "postal_code": "620008",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 10.806496,
        "long": 78.709497,
        "details": "DMart Trichy, Tiruchirappalli",
        "google_place_id": "ChIJ4wD_8hD1qjsRi3Kx23c160Y"
      },
      "bounds": [
        10.64498,
        78.388613,
        11.184185,
        78.850209
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "mysore",
      "name": "Mysore",
      "key": "city_mysore_v2",
      "seo_city_key": "india|mysore",
      "customer_city": "city_mysore_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "mysore",
        "Mysore"
      ],
      "subcities": [
        "mysore"
      ],
      "city_address_hint": "Mysore Palace, Mysore",
      "url_name": "mysore",
      "country_name": "India",
      "postal_code": "570001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 12.305163,
        "long": 76.6529862,
        "details": "Mysore Palace, Mysore",
        "google_place_id": "ChIJ-aH5AxFwrzsRDdokoeK6f8M"
      },
      "bounds": [
        12.089272,
        75.954576,
        12.418042,
        76.756085
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "hunsur",
      "name": "hunsur",
      "key": "city_hunsur_v2",
      "seo_city_key": "India|hunsur",
      "customer_city": "city_hunsur_v2",
      "state": "Mysore",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "bamboo flat",
        "hunsur"
      ],
      "subcities": [],
      "city_address_hint": "new, Post Office Rd, Muthumariyamman Kovil, Hunsur, Karnataka 571105",
      "url_name": "hunsur",
      "country_name": "India",
      "postal_code": "571105",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.70817,
        "long": 92.7211179,
        "details": "new, Post Office Rd, Muthumariyamman Kovil, Hunsur, Karnataka 571105",
        "google_place_id": "ChIJxVYP_Dq-iDARSdQXYYX4Og4"
      },
      "bounds": [
        12.582662,
        75.769875,
        12.588198,
        75.773272
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Bulandshahr",
      "name": "Bulandshahr",
      "key": "city_bulandshahr_v2",
      "seo_city_key": "India|Bulandshahr",
      "customer_city": "city_bulandshahr_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Bulandshahr"
      ],
      "subcities": [],
      "city_address_hint": " Ansari Rd, opp. Old Jail, Laxmi Nagar, Bulandshahr, Uttar Pradesh 203001",
      "url_name": "Bulandshahr",
      "country_name": "India",
      "postal_code": "203001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.70817,
        "long": 92.7211179,
        "details": " Ansari Rd, opp. Old Jail, Laxmi Nagar, Bulandshahr, Uttar Pradesh 203001",
        "google_place_id": "ChIJxVYP_Dq-iDARSdQXYYX4Og4"
      },
      "bounds": [
        28.162625,
        77.70266,
        28.643106,
        78.457407
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Nandurbar",
      "name": "Nandurbar",
      "key": "city_nandurbar_v2",
      "seo_city_key": "India|Nandurbar",
      "customer_city": "city_nandurbar_v2",
      "state": "Maharastra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "bamboo flat",
        "Nandurbar"
      ],
      "subcities": [],
      "city_address_hint": "969W+F8M, Lokmanya Colony, Nehru Nagar, Nandurbar, Maharashtra 425412",
      "url_name": "Nandurbar",
      "country_name": "India",
      "postal_code": "425412",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.70817,
        "long": 92.7211179,
        "details": "969W+F8M, Lokmanya Colony, Nehru Nagar, Nandurbar, Maharashtra 425412",
        "google_place_id": "ChIJxVYP_Dq-iDARSdQXYYX4Og4"
      },
      "bounds": [
        21.373595,
        74.02305,
        22.35337,
        75.054955
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Bathinda",
      "name": "Bathinda",
      "key": "city_bathinda_v2",
      "seo_city_key": "India|Bathinda",
      "customer_city": "city_bathinda_v2",
      "state": "Punjab",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "bamboo flat",
        "Bathinda"
      ],
      "subcities": [],
      "city_address_hint": "6W3X+VF5, Civil Lines, Bathinda, Punjab 151001",
      "url_name": "Bathinda",
      "country_name": "India",
      "postal_code": "151001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.70817,
        "long": 92.7211179,
        "details": "6W3X+VF5, Civil Lines, Bathinda, Punjab 151001",
        "google_place_id": "ChIJxVYP_Dq-iDARSdQXYYX4Og4"
      },
      "bounds": [
        29.966304,
        74.751286,
        30.492283,
        75.339006
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Cachar",
      "name": "Cachar",
      "key": "city_cachar_v2",
      "seo_city_key": "India|Cachar",
      "customer_city": "city_cachar_v2",
      "state": "Assam",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Cachar",
        "cachar",
        "Cachar"
      ],
      "subcities": [],
      "city_address_hint": "QVJ5+V34, Bagpur Pt II, Assam 788101, India",
      "url_name": "Cachar",
      "country_name": "India",
      "postal_code": "788101",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 24.7821253,
        "long": 92.8577105,
        "details": "QVJ5+V34, Bagpur Pt II, Assam 788101, India",
        "google_place_id": "ChIJa1jJlXhKTjcR6Nk1p8A1HZI"
      },
      "bounds": [
        24.259084,
        92.365673,
        25.12221,
        93.190221
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "rajahmundry",
      "name": "Rajahmundry",
      "key": "city_rajahmundry_v2",
      "seo_city_key": "india|rajahmundry",
      "customer_city": "city_rajahmundry_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "rajahmundry",
        "Rajahmundry"
      ],
      "subcities": [
        "rajahmundry"
      ],
      "city_address_hint": "Kerala Complex, Rajahmundry",
      "url_name": "rajahmundry",
      "country_name": "India",
      "postal_code": "533103",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 17.008326,
        "long": 81.783572,
        "details": "Kerala Complex, Rajahmundry",
        "google_place_id": "ChIJgVQmm_SjNzoRcm-JJOdsmfM"
      },
      "bounds": [
        16.003578,
        80.891003,
        17.456454,
        82.727776
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "sonipat",
      "name": "Sonipat",
      "key": "city_sonipat_v2",
      "seo_city_key": "india|sonipat",
      "customer_city": "city_sonipat_v2",
      "state": "Haryana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "sonipat",
        "Sonipat"
      ],
      "subcities": [
        "sonipat"
      ],
      "city_address_hint": "Civil Hospital, Sonipat",
      "url_name": "sonipat",
      "country_name": "India",
      "postal_code": "131001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 28.99121,
        "long": 77.03655,
        "details": "Civil Hospital, Sonipat",
        "google_place_id": "ChIJUz5Fij6wDTkRG-nMsZnIDAs"
      },
      "bounds": [
        28.947874,
        76.554788,
        29.476509,
        77.431292
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ratlam",
      "name": "Ratlam",
      "key": "city_ratlam_v2",
      "seo_city_key": "India|Ratlam",
      "customer_city": "city_ratlam_v2",
      "state": "Madhya Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ratlam",
        "ratlam",
        "Ratlam"
      ],
      "subcities": [
        "ratlam"
      ],
      "city_address_hint": "62, near Radha Krishn Mandir, Katju Nagar, Gandhi Nagar, Ratlam, Madhya Pradesh 457001, India",
      "url_name": "ratlam",
      "country_name": "India",
      "postal_code": "457001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 23.3315103,
        "long": 75.0366677,
        "details": "62, near Radha Krishn Mandir, Katju Nagar, Gandhi Nagar, Ratlam, Madhya Pradesh 457001, India",
        "google_place_id": "ChIJW5sic6P-YzkRcFrkXUAiDMs"
      },
      "bounds": [
        23.190986,
        74.829174,
        23.659104,
        75.259152
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ludhiana",
      "name": "Ludhiana",
      "key": "city_ludhiana_v2",
      "seo_city_key": "india|ludhiana",
      "customer_city": "city_ludhiana_v2",
      "state": "Punjab",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "ludhiana"
      ],
      "subcities": [
        "Ludhiana",
        "ludhiana"
      ],
      "city_address_hint": "Sarabha Nagar, Ludhiana",
      "url_name": "ludhiana",
      "country_name": "India",
      "postal_code": "141401",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 30.89274,
        "long": 75.81882,
        "details": "Sarabha Nagar, Ludhiana",
        "google_place_id": "ChIJtWw19tGDGjkRpQwYst-1eHg"
      },
      "bounds": [
        30.82956,
        75.75622,
        30.95256,
        75.97234
      ],
      "offices": [
        {
          "name": "Ludhiana",
          "is_live": false,
          "address": "3rd floor, Bedi Electronics World, Ferozepur Road, Bhai Bala Chowk, Civil Lines, Ludhiana - 141001",
          "subcities": [
            "ludhiana"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 30.89274,
            "long": 75.81882
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "bhubaneswar",
      "name": "Bhubaneswar",
      "key": "city_bhubaneswar_v2",
      "seo_city_key": "india|bhubaneswar",
      "customer_city": "city_bhubaneswar_v2",
      "state": "Orissa",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "bhubaneswar"
      ],
      "subcities": [
        "Bhunaneswar",
        "bhubaneswar"
      ],
      "city_address_hint": "Neeladri Vihar, Bhubaneswar",
      "url_name": "bhubaneswar",
      "country_name": "India",
      "postal_code": "751001",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 19.97257,
        "long": 72.74742,
        "details": "Neeladri Vihar, Bhubaneswar",
        "google_place_id": "ChIJE7do_FQIGToR9Hx3bcQPnTI"
      },
      "bounds": [
        19.652751,
        85.441422,
        20.386127,
        86.844235
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "prakasam",
      "name": "Prakasam",
      "key": "city_prakasam_v2",
      "seo_city_key": "India|Prakasam",
      "customer_city": "city_prakasam_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Prakasam",
        "prakasam",
        "Prakasam"
      ],
      "subcities": [
        "prakasam"
      ],
      "city_address_hint": "2X89+2M Peda Arutla, Andhra Pradesh, India",
      "url_name": "prakasam",
      "country_name": "India",
      "postal_code": "523331",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 16.015009,
        "long": 78.969231,
        "details": "2X89+2M Peda Arutla, Andhra Pradesh, India",
        "google_place_id": "GhIJ8SHyp9cDMEARPdF14Qe-U0A"
      },
      "bounds": [
        15.122867,
        78.971379,
        16.122521,
        80.5781
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "nellore",
      "name": "Nellore",
      "key": "city_nellore_v2",
      "seo_city_key": "India|Nellore",
      "customer_city": "city_nellore_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Nellore",
        "nellore",
        "Nellore"
      ],
      "subcities": [
        "nellore"
      ],
      "city_address_hint": "15-365, Brindavanam, Nellore, Andhra Pradesh 524001, India",
      "url_name": "nellore",
      "country_name": "India",
      "postal_code": "524001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 14.4425987,
        "long": 79.98645599999999,
        "details": "15-365, Brindavanam, Nellore, Andhra Pradesh 524001, India",
        "google_place_id": "ChIJcYeVDsqMTDoRVR8WJSBsA9M"
      },
      "bounds": [
        13.765563,
        79.314937,
        15.118903,
        80.333361
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "junagadh",
      "name": "Junagadh",
      "key": "city_junagadh_v2",
      "seo_city_key": "India|Junagadh",
      "customer_city": "city_junagadh_v2",
      "state": "Gujarat",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Junagadh",
        "junagadh",
        "Junagadh"
      ],
      "subcities": [
        "junagadh"
      ],
      "city_address_hint": "Jayshree Rd, Joshipura, Junagadh, Gujarat 362001, India",
      "url_name": "junagadh",
      "country_name": "India",
      "postal_code": "362001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 21.5222203,
        "long": 70.4579436,
        "details": "Jayshree Rd, Joshipura, Junagadh, Gujarat 362001, India",
        "google_place_id": "ChIJU38naowBWDkRSG6oIIUvtRM"
      },
      "bounds": [
        20.427531,
        68.546565,
        24.212099,
        71.539699
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "sharjah",
      "name": "Sharjah",
      "key": "city_sharjah_v2",
      "seo_city_key": "saudi_arabia|sharjah",
      "customer_city": "city_sharjah_v2",
      "state": "Sharjah state",
      "country_key": "UAE",
      "country_id": "UAE",
      "regex": [
        "sharjah",
        "??????",
        "kalba",
        "al majaz 1"
      ],
      "subcities": [
        "Sharjah",
        "sharjah"
      ],
      "city_address_hint": "Safari Mall Sharjah",
      "url_name": "sharjah",
      "country_name": "UAE",
      "postal_code": "33876",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 25.304563,
        "long": 55.452062,
        "details": "Safari Mall Sharjah",
        "google_place_id": "ChIJYwnq0CFfXz4RLLdpXUpAs9Q"
      },
      "bounds": [
        25.30047,
        55.34936,
        25.493015,
        55.723073
      ],
      "offices": [],
      "timezone": "Asia/Dubai"
    },
    {
      "is_live": true,
      "regex_key": "tirupati",
      "name": "Tirupati",
      "key": "city_tirupati_v2",
      "seo_city_key": "India|Tirupati",
      "customer_city": "city_tirupati_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Tirupati",
        "tirupati",
        "Tirupati"
      ],
      "subcities": [
        "tirupati"
      ],
      "city_address_hint": "17/5051A, Rajendra Nagar, Tilak Nagar, Tirupati, Andhra Pradesh 517501, India",
      "url_name": "tirupati",
      "country_name": "India",
      "postal_code": "517501",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 13.6287557,
        "long": 79.4191795,
        "details": "17/5051A, Rajendra Nagar, Tilak Nagar, Tirupati, Andhra Pradesh 517501, India",
        "google_place_id": "ChIJJwRiiA9LTToRrAzK2tFSQc8"
      },
      "bounds": [
        13.035666,
        78.537798,
        13.763113,
        79.786834
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "gondia",
      "name": "Gondia",
      "key": "city_gondia_v2",
      "seo_city_key": "India|Gondia",
      "customer_city": "city_gondia_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Gondia",
        "gondia",
        "Gondia"
      ],
      "subcities": [
        "gondia"
      ],
      "city_address_hint": "K.K. Complex, Shree Talkies Road, F53W+XCG, Bajaj Nagar, Gondia, Maharashtra 441601, India",
      "url_name": "gondia",
      "country_name": "India",
      "postal_code": "441601",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 21.4549477,
        "long": 80.19607119999999,
        "details": "K.K. Complex, Shree Talkies Road, F53W+XCG, Bajaj Nagar, Gondia, Maharashtra 441601, India",
        "google_place_id": "ChIJdQFLCq2uKzoRloGIIdQHhnE"
      },
      "bounds": [
        20.789819,
        79.921202,
        21.542511,
        80.591926
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "raipur",
      "name": "Raipur",
      "key": "city_raipur_v2",
      "seo_city_key": "india|raipur",
      "customer_city": "city_raipur_v2",
      "state": "Chattisgarh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "raipur",
        "Raipur"
      ],
      "subcities": [
        "raipur",
        "Raipur"
      ],
      "city_address_hint": "7J2J+F5X, Ganjpara, Station Road, Moudhapara, Raipur, Chhattisgarh 492001, India",
      "url_name": "raipur",
      "country_name": "India",
      "postal_code": "492001",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 21.251323,
        "long": 81.630454,
        "details": "7J2J+F5X, Ganjpara, Station Road, Moudhapara, Raipur, Chhattisgarh 492001, India",
        "google_place_id": "ChIJ9XP225PdKDoRH2xbw2m40_k"
      },
      "bounds": [
        20.873439,
        80.616484,
        21.571755,
        81.92111
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "chandrapur",
      "name": "Chandrapur",
      "key": "city_chandrapur_v2",
      "seo_city_key": "India|Chandrapur",
      "customer_city": "city_chandrapur_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Chandrapur",
        "chandrapur",
        "Chandrapur"
      ],
      "subcities": [
        "chandrapur"
      ],
      "city_address_hint": "X76W+JF6, Civil Lines, Chandrapur, Maharashtra 442402, India",
      "url_name": "chandrapur",
      "country_name": "India",
      "postal_code": "442402",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 19.9615398,
        "long": 79.2961468,
        "details": "X76W+JF6, Civil Lines, Chandrapur, Maharashtra 442402, India",
        "google_place_id": "ChIJM8OtZNHV0jsRVRvwhX3lCkQ"
      },
      "bounds": [
        19.515665,
        78.81343,
        20.536847,
        80.570555
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Taif",
      "name": "Taif",
      "key": "city_taif_v2",
      "seo_city_key": "Saudi Arabia|Taif",
      "customer_city": "city_taif_v2",
      "state": "Mecca",
      "country_key": "KSA",
      "country_id": "KSA",
      "regex": [
        "Taif",
        "taif"
      ],
      "subcities": [],
      "city_address_hint": "3139 Al Dammam, 7220, Al Rayyan, At Taif 26523, Saudi Arabia",
      "url_name": "Taif",
      "country_name": "KSA",
      "postal_code": "26513",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 21.2840782,
        "long": 40.42481919999999,
        "details": "3139 Al Dammam, 7220, Al Rayyan, At Taif 26523, Saudi Arabia",
        "google_place_id": "ChIJLz-jsMyO6RURp6IfNOHlP_o"
      },
      "bounds": [
        21.149246,
        40.243838,
        21.599509,
        40.741171
      ],
      "offices": [],
      "timezone": "Asia/Riyadh"
    },
    {
      "is_live": true,
      "regex_key": "Abha",
      "name": "Abha",
      "key": "city_abha_v2",
      "seo_city_key": "Saudi Arabia|Abha",
      "customer_city": "city_abha_v2",
      "state": "'Asir",
      "country_key": "KSA",
      "country_id": "KSA",
      "regex": [
        "Abha",
        "abha",
        "Abha"
      ],
      "subcities": [],
      "city_address_hint": "6GW6+JM4, As Sharafiyah, Abha 62542, Saudi Arabia",
      "url_name": "Abha",
      "country_name": "KSA",
      "postal_code": "62542",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 18.2464685,
        "long": 42.5117238,
        "details": "6GW6+JM4, As Sharafiyah, Abha 62542, Saudi Arabia",
        "google_place_id": "ChIJMQlyFWNU4xURtBmJcYxVd6E"
      },
      "bounds": [
        18.025425,
        42.383194,
        18.419929,
        42.914143
      ],
      "offices": [],
      "timezone": "Asia/Riyadh"
    },
    {
      "is_live": true,
      "regex_key": "kalaburgi",
      "name": "Kalaburgi",
      "key": "city_kalaburgi_v2",
      "seo_city_key": "India|Kalaburgi",
      "customer_city": "city_kalaburgi_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Kalaburgi",
        "kalaburgi",
        "Kalaburgi"
      ],
      "subcities": [
        "kalaburgi"
      ],
      "city_address_hint": "37, Public Garden Rd, Mahaveer Nagar, Halbarga, Brhampur, Kalaburagi, Karnataka 585105, India",
      "url_name": "kalaburgi",
      "country_name": "India",
      "postal_code": "585105",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 17.329731,
        "long": 76.8342957,
        "details": "37, Public Garden Rd, Mahaveer Nagar, Halbarga, Brhampur, Kalaburagi, Karnataka 585105, India",
        "google_place_id": "ChIJV06CW0XHyDsRn-1XaTbjy0Q"
      },
      "bounds": [
        16.939424,
        76.381406,
        17.656622,
        77.654843
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jhansi",
      "name": "Jhansi",
      "key": "city_jhansi_v2",
      "seo_city_key": "India|Jhansi",
      "customer_city": "city_jhansi_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Jhansi",
        "jhansi",
        "Jhansi"
      ],
      "subcities": [
        "jhansi"
      ],
      "city_address_hint": "कुंज बिहारी मंदिर के पास आँटिया तालाब, Prathvipur, Civil Lines, Jhansi, Jhansi Rly. Settl, Uttar Pradesh 284001, India",
      "url_name": "jhansi",
      "country_name": "India",
      "postal_code": "284001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.4484257,
        "long": 78.5684594,
        "details": "कुंज बिहारी मंदिर के पास आँटिया तालाब, Prathvipur, Civil Lines, Jhansi, Jhansi Rly. Settl, Uttar Pradesh 284001, India",
        "google_place_id": "ChIJA3e6WNR2dzkRyoE0XKXN6ZY"
      },
      "bounds": [
        25.23142,
        78.346253,
        25.936126,
        79.226017
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "firozabad",
      "name": "Firozabad",
      "key": "city_firozabad_v2",
      "seo_city_key": "India|Firozabad",
      "customer_city": "city_firozabad_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Firozabad",
        "firozabad",
        "Firozabad"
      ],
      "subcities": [
        "firozabad"
      ],
      "city_address_hint": "10A, Vibhav Nagar, Arya Nagar, Firozabad, Uttar Pradesh 283203, India",
      "url_name": "firozabad",
      "country_name": "India",
      "postal_code": "283203",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 27.1591961,
        "long": 78.3957331,
        "details": "10A, Vibhav Nagar, Arya Nagar, Firozabad, Uttar Pradesh 283203, India",
        "google_place_id": "ChIJkem9cphGdDkR7qwRjDpmhN8"
      },
      "bounds": [
        26.969844,
        78.209105,
        27.279164,
        78.81218
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Vijayapura",
      "name": "Vijayapura",
      "key": "city_vijayapura_v2",
      "seo_city_key": "India|Vijayapura",
      "customer_city": "city_vijayapura_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Vijayapura",
        "vijayapura",
        "Vijayapura"
      ],
      "subcities": [],
      "city_address_hint": "Sahu Nagar, RPJ5+7X3, Upali Burj Area, Vijayapura, Karnataka 586101, India",
      "url_name": "Vijayapura",
      "country_name": "India",
      "postal_code": "586101",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 16.830652,
        "long": 75.709912,
        "details": "Sahu Nagar, RPJ5+7X3, Upali Burj Area, Vijayapura, Karnataka 586101, India",
        "google_place_id": "ChIJLwIox4H_xjsRuJgr-sNyJr4"
      },
      "bounds": [
        16.559285,
        75.491267,
        17.142594,
        76.093497
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "West Tripura",
      "name": "West Tripura",
      "key": "city_west_tripura_v2",
      "seo_city_key": "India|West Tripura",
      "customer_city": "city_west_tripura_v2",
      "state": "Tripura",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "West Tripura",
        "west tripura",
        "West Tripura"
      ],
      "subcities": [],
      "city_address_hint": "VCX3+VWG, Sibnagar, Tripura 799210, India",
      "url_name": "West Tripura",
      "country_name": "India",
      "postal_code": "799210",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 23.899682,
        "long": 91.4048249,
        "details": "VCX3+VWG, Sibnagar, Tripura 799210, India",
        "google_place_id": "ChIJ-_qVchP0UzcRHKwroj1Ylds"
      },
      "bounds": [
        23.737797,
        91.213949,
        23.98358,
        91.546685
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "puducherry",
      "name": "Puducherry",
      "key": "city_puducherry_v2",
      "seo_city_key": "India|Puducherry",
      "customer_city": "city_puducherry_v2",
      "state": "Puducherry",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Puducherry",
        "puducherry",
        "Puducherry"
      ],
      "subcities": [
        "Puducherry"
      ],
      "city_address_hint": "Pondicherry, Aruthra Nagar, Puducherry, 605009, India",
      "url_name": "puducherry",
      "country_name": "India",
      "postal_code": "605009",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.9415915,
        "long": 79.8083133,
        "details": "Pondicherry, Aruthra Nagar, Puducherry, 605009, India",
        "google_place_id": "ChIJz89JjqthUzoRTrDw0ibTa8w"
      },
      "bounds": [
        11.828952,
        79.60953,
        12.174518,
        80.011068
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ratnagiri",
      "name": "Ratnagiri",
      "key": "city_maharashtra_ratnagiri_v2",
      "seo_city_key": "India|Ratnagiri",
      "customer_city": "city_maharashtra_ratnagiri_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ratnagiri",
        "ratnagiri",
        "Ratnagiri"
      ],
      "subcities": [
        "ratnagiri"
      ],
      "city_address_hint": "X8R6+3RJ, Abhyudhya Nagar, Ratnagiri, Maharashtra 415612, India",
      "url_name": "ratnagiri",
      "country_name": "India",
      "postal_code": "415612",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 16.990215,
        "long": 73.31202329999999,
        "details": "X8R6+3RJ, Abhyudhya Nagar, Ratnagiri, Maharashtra 415612, India",
        "google_place_id": "ChIJf7umORgN6jsRYWW_eZuWq2M"
      },
      "bounds": [
        16.708219,
        72.858775,
        17.853331,
        73.706246
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "darjeeling",
      "name": "Darjeeling",
      "key": "city_darjeeling_v2",
      "seo_city_key": "India|Darjeeling",
      "customer_city": "city_darjeeling_v2",
      "state": "West Bengal",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Darjeeling",
        "darjeeling",
        "Darjeeling"
      ],
      "subcities": [
        "darjeeling"
      ],
      "city_address_hint": "18, Hill Cart Rd, West Point, Darjeeling, West Bengal 734101, India",
      "url_name": "darjeeling",
      "country_name": "India",
      "postal_code": "734102",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 27.0410218,
        "long": 88.2662745,
        "details": "18, Hill Cart Rd, West Point, Darjeeling, West Bengal 734101, India",
        "google_place_id": "ChIJuwH1TGUu5DkRKnDUeVlVdUE"
      },
      "bounds": [
        26.429076,
        87.97255,
        27.132919,
        88.939948
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "karur",
      "name": "Karur",
      "key": "city_karur_v2",
      "seo_city_key": "India|Karur",
      "customer_city": "city_karur_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Karur",
        "karur",
        "Karur"
      ],
      "subcities": [
        "karur"
      ],
      "city_address_hint": "773, E B Colony, North Gandhi Gramam, Karur, Tamil Nadu 639004, India",
      "url_name": "karur",
      "country_name": "India",
      "postal_code": "639001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 10.9600778,
        "long": 78.07660360000001,
        "details": "773, E B Colony, North Gandhi Gramam, Karur, Tamil Nadu 639004, India",
        "google_place_id": "ChIJjzmVJAcvqjsRG599H3r8fJQ"
      },
      "bounds": [
        10.902149,
        77.980099,
        11.004219,
        78.117021
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "dindigul",
      "name": "Dindigul",
      "key": "city_dindigul_v2",
      "seo_city_key": "India|Dindigul",
      "customer_city": "city_dindigul_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Dindigul",
        "dindigul",
        "Dindigul"
      ],
      "subcities": [
        "dindigul"
      ],
      "city_address_hint": "153, W Car St, Dindigul, Begambur, Tamil Nadu 624001, India",
      "url_name": "dindigul",
      "country_name": "India",
      "postal_code": "624001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 10.362661,
        "long": 77.969166,
        "details": "153, W Car St, Dindigul, Begambur, Tamil Nadu 624001, India",
        "google_place_id": "ChIJvzJcx_aqADsRpvc0CCaJJPc"
      },
      "bounds": [
        10.358249,
        77.961175,
        10.366685,
        77.977801
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "saharsa",
      "name": "Saharsa",
      "key": "city_saharsa_v2",
      "seo_city_key": "India|Saharsa",
      "customer_city": "city_saharsa_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Saharsa",
        "saharsa",
        "Saharsa"
      ],
      "subcities": [
        "saharsa"
      ],
      "city_address_hint": "VHGV+X43, Naya Bazar, Saharsa, Bihar 852201, India",
      "url_name": "saharsa",
      "country_name": "India",
      "postal_code": "852201",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.8773651,
        "long": 86.5927887,
        "details": "VHGV+X43, Naya Bazar, Saharsa, Bihar 852201, India",
        "google_place_id": "ChIJz417rpU97jkR5Yb-IfXQvJA"
      },
      "bounds": [
        25.695315,
        86.428957,
        25.998889,
        86.660683
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "madinah",
      "name": "Al Madinah",
      "key": "city_madinah_v2",
      "seo_city_key": "Saudi Arabia|Al Furaysh",
      "customer_city": "city_madinah_v2",
      "state": "Al Madinah",
      "country_key": "KSA",
      "country_id": "KSA",
      "regex": [
        "Al Furaysh",
        "al furaysh",
        "Al Furaysh"
      ],
      "subcities": [
        "madinah"
      ],
      "city_address_hint": "677F+GH3, Al Furaysh 42537, Saudi Arabia",
      "url_name": "madinah",
      "country_name": "KSA",
      "postal_code": "42331",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 24.2137683,
        "long": 39.2739088,
        "details": "677F+GH3, Al Furaysh 42537, Saudi Arabia",
        "google_place_id": "ChIJ6cPgkYAqvBURWd7HIU_P1Mw"
      },
      "bounds": [
        24.087216,
        39.135447,
        24.668312,
        40.005426
      ],
      "offices": [],
      "timezone": "Asia/Riyadh"
    },
    {
      "is_live": true,
      "regex_key": "hofuf",
      "name": "Al Hufūf",
      "key": "city_hufuf_v2",
      "seo_city_key": "Saudi Arabia|Al Hufūf",
      "customer_city": "city_hufuf_v2",
      "state": "Eastern Province",
      "country_key": "KSA",
      "country_id": "KSA",
      "regex": [
        "Al Hufuf",
        "al hufuf",
        "Al Hufūf"
      ],
      "subcities": [
        "hofuf"
      ],
      "city_address_hint": "9HJQ+2G6, Historicalcenter Hafuf, Al Hofuf 36361, Saudi Arabia",
      "url_name": "hofuf",
      "country_name": "KSA",
      "postal_code": "36361",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 25.380026,
        "long": 49.5887652,
        "details": "9HJQ+2G6, Historicalcenter Hafuf, Al Hofuf 36361, Saudi Arabia",
        "google_place_id": "ChIJW9_SDuOWNz4RzXAjAan6QCM"
      },
      "bounds": [
        25.216356,
        49.440879,
        25.582898,
        49.783001
      ],
      "offices": [],
      "timezone": "Asia/Riyadh"
    },
    {
      "is_live": true,
      "regex_key": "jammu",
      "name": "Jammu",
      "key": "city_jammu_v2",
      "seo_city_key": "India|Jammu",
      "customer_city": "city_jammu_v2",
      "state": "Jammu and Kashmir",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Jammu",
        "jammu",
        "Jammu"
      ],
      "subcities": [
        "jammu"
      ],
      "city_address_hint": "PVG4+JRR, Resham Ghar Colony, Jammu, 180016",
      "url_name": "jammu",
      "country_name": "India",
      "postal_code": "180016",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 32.7266016,
        "long": 74.8570259,
        "details": "PVG4+JRR, Resham Ghar Colony, Jammu, 180016",
        "google_place_id": "ChIJJTWdFr-EHjkRjf247og0Iw8"
      },
      "bounds": [
        32.328825,
        74.138437,
        33.946442,
        75.703371
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "abudhabi",
      "name": "Abu Dhabi",
      "key": "city_abudhabi_v2",
      "seo_city_key": "united_arab_emirates|abu_dhabi",
      "customer_city": "city_abudhabi_v2",
      "state": "Abu Dhabi",
      "country_key": "UAE",
      "country_id": "UAE",
      "regex": [
        "abu dhabi",
        "??? ???",
        "al ain city",
        "al mafraq",
        "khalifah a city",
        "musaffah city"
      ],
      "subcities": [
        "Abu-Dhabi",
        "abu-dhabi",
        "abu dhabi",
        "??? ???"
      ],
      "city_address_hint": "Khalidiyah Street - Abu Dhabi - United Arab Emirates",
      "url_name": "abudhabi",
      "country_name": "UAE",
      "postal_code": "380051",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 25.1975148,
        "long": 55.2748732,
        "details": "Khalidiyah Street - Abu Dhabi - United Arab Emirates",
        "google_place_id": "ChIJO7H92gtmXj4RP0WTA_Ogr8A"
      },
      "bounds": [
        24.013185,
        54.127906,
        24.713429,
        55.088178
      ],
      "offices": [],
      "timezone": "Asia/Dubai"
    },
    {
      "is_live": true,
      "regex_key": "singapore",
      "name": "Singapore",
      "key": "city_singapore_v2",
      "seo_city_key": "singapore|singapore",
      "customer_city": "city_singapore_v2",
      "state": "Singapore",
      "country_key": "SGP",
      "country_id": "SGP",
      "regex": [
        "singapore"
      ],
      "subcities": [
        "Singapore",
        "singapore"
      ],
      "city_address_hint": "Orchard Rd, Singapore",
      "url_name": "singapore",
      "country_name": "Singapore",
      "postal_code": "238857",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 1.303224,
        "long": 103.836156,
        "details": "Orchard Rd, Singapore",
        "google_place_id": "ChIJSSB81ZMZ2jERTxekeovnJv0"
      },
      "bounds": [
        1.20531,
        103.5871,
        1.49997,
        104.04475
      ],
      "offices": [
        {
          "name": "Singapore",
          "is_live": true,
          "address": "8 Burn Rd, Trivex, Singapore 369977",
          "subcities": [
            "Singapore"
          ],
          "office_type": [
            "corporate",
            "training"
          ],
          "location_mapping": {
            "lat": 1.337829,
            "long": 103.885177
          }
        }
      ],
      "timezone": "Asia/Singapore"
    },
    {
      "is_live": true,
      "regex_key": "thiruvananthapuram",
      "name": "Thiruvananthapuram",
      "key": "city_thiruvananthapuram_v2",
      "seo_city_key": "india|thiruvananthapuram",
      "customer_city": "city_thiruvananthapuram_v2",
      "state": "Kerala",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "thiruvananthapuram",
        "Thiruvananthapuram",
        "Trivandrum",
        "trivandrum"
      ],
      "subcities": [
        "thiruvananthapuram",
        "Thiruvananthapuram",
        "Trivandrum",
        "trivandrum"
      ],
      "city_address_hint": "FXQ3+35J, Thampanoor, Thiruvananthapuram, Kerala 695014, India",
      "url_name": "thiruvananthapuram",
      "country_name": "India",
      "postal_code": "695014",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 8.487486,
        "long": 76.952868,
        "details": "FXQ3+35J, Thampanoor, Thiruvananthapuram, Kerala 695014, India",
        "google_place_id": "ChIJRWIgqqi7BTsRnwu3kfhXzE4"
      },
      "bounds": [
        8.293807,
        76.691403,
        8.792803,
        77.270936
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "madurai",
      "name": "Madurai",
      "key": "city_madurai_v2",
      "seo_city_key": "india|madurai",
      "customer_city": "city_madurai_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "madurai",
        "Madurai"
      ],
      "subcities": [
        "madurai"
      ],
      "url_name": "madurai",
      "country_name": "India",
      "postal_code": "625001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 9.920873,
        "long": 78.112276,
        "details": "Hotel Supreme, Madurai",
        "google_place_id": "ChIJhUS6dIfFADsR6QNqZJ1JR88110"
      },
      "bounds": [
        9.37954,
        77.79542,
        10.23206,
        78.54798
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jamshedpur",
      "name": "Jamshedpur",
      "key": "city_jamshedpur_v2",
      "seo_city_key": "india|jamshedpur",
      "customer_city": "city_jamshedpur_v2",
      "state": "Jharkhand",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "jamshedpur",
        "tatanagar"
      ],
      "subcities": [
        "jamshedpur",
        "Jamshedpur"
      ],
      "url_name": "jamshedpur",
      "country_name": "India",
      "postal_code": "831001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 22.7838999,
        "long": 86.1740702,
        "details": "Parvati Ghat",
        "google_place_id": "ChIJteLwiRnj9TkRRLPpHOjI7g4"
      },
      "bounds": [
        22.63453,
        86.06733,
        22.90679,
        86.37765
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "agra",
      "name": "Agra",
      "key": "city_agra_v2",
      "seo_city_key": "india|agra",
      "customer_city": "city_agra_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Agra",
        "agra"
      ],
      "subcities": [
        "Agra",
        "agra"
      ],
      "city_address_hint": "Sanjay Place",
      "url_name": "agra",
      "country_name": "India",
      "postal_code": "282002",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 27.1987,
        "long": 78.006,
        "details": "Sanjay Place",
        "google_place_id": "ChIJ2UEvfIUNdDkRQjtSqTjvSng"
      },
      "bounds": [
        27.1024,
        77.8746,
        27.2365,
        78.0909
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "lucknow",
      "name": "Lucknow",
      "key": "city_lucknow_v2",
      "seo_city_key": "india|lucknow",
      "customer_city": "city_lucknow_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "lucknow"
      ],
      "subcities": [
        "Lucknow",
        "lucknow"
      ],
      "city_address_hint": "eg. Gomti Nagar",
      "url_name": "lucknow",
      "country_name": "India",
      "postal_code": "226004",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 26.851311,
        "long": 81.012421,
        "details": "Gomti Nagar, Lucknow",
        "google_place_id": "ChIJQ6hg_En9mzkRaj9im-Fy_JI"
      },
      "bounds": [
        26.65993,
        80.74154,
        27.03848,
        81.23976
      ],
      "offices": [
        {
          "name": "Lucknow",
          "is_live": true,
          "address": "3rd Floor, Eldeco corporate chamber 1, Vibhuti khand, Gomti Nagar, Lucknow - 226010",
          "subcities": [
            "Lucknow"
          ],
          "office_type": [
            "corporate",
            "training",
            "business",
            "support"
          ],
          "location_mapping": {
            "lat": 26.859022,
            "long": 80.98721
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    }
  ],
  "countries": [
    {
      "is_country_live": true,
      "isd_code": "+966",
      "isd_code_int": 966,
      "phone_validation": {
        "number_length": [
          9
        ]
      },
      "country_key": "KSA",
      "country_id": "KSA",
      "iso_code": "SA",
      "country_name": "KSA",
      "distance_unit": "Km",
      "display_name": "Saudi Arabia",
      "google_country_filter": "SA",
      "locale": "en_US",
      "currency_code": "SAR",
      "currency_code_symbol": "SAR",
      "tz": "Asia/Riyadh",
      "country_flag": {
        "low_res": "/t_low_res_template",
        "medium_res": "/t_medium_res_template",
        "high_res": "/t_high_res_template",
        "s3_path": "/images/growth/home-screen/1612361663672-94027b.png",
        "base_url": "https://res.cloudinary.com/urbanclap/image/upload",
        "thumb": {
          "low_res": "/t_low_res_portfolio_thumb,q_auto:low,f_auto",
          "medium_res": "/t_medium_res_portfolio_thumb,q_auto:low,f_auto",
          "high_res": "/t_high_res_portfolio_thumb,q_auto:low,f_auto"
        },
        "medium": {
          "low_res": "/t_low_res_portfolio_medium,q_auto:low,f_auto",
          "medium_res": "/t_medium_res_portfolio_medium,q_auto:low,f_auto",
          "high_res": "/t_high_res_portfolio_medium,q_auto:low,f_auto"
        }
      },
      "company_details": {
        "legal_name": "Urban Company Arabia for Information Technology",
        "name": "Urban Company",
        "domain_name": "www.urbancompany.com",
        "logo": ""
      },
      "customer_supported_languages": {
        "default_language": {
          "code": "en",
          "key": "english",
          "value": "English"
        },
        "supported_languages": [
          {
            "code": "en",
            "key": "english",
            "value": "English"
          },
          {
            "code": "ar",
            "key": "arabic",
            "value": "Arabic"
          }
        ]
      },
      "provider_supported_languages": {
        "default_language": {
          "code": "en",
          "key": "english",
          "value": "English"
        },
        "supported_languages": [
          {
            "code": "en",
            "key": "english",
            "value": "English"
          },
          {
            "code": "ar",
            "key": "arabic",
            "value": "Arabic"
          }
        ]
      },
      "login_sources": [
        {
          "name": "otp",
          "skip_email": false,
          "skip_name": false
        },
        {
          "name": "otp_without_email",
          "skip_email": true,
          "skip_name": true
        },
        {
          "name": "truecaller",
          "skip_email": false,
          "skip_name": false
        },
        {
          "name": "otp_with_email",
          "skip_email": false,
          "skip_name": true,
          "min_version": {
            "android": "7.2.01",
            "ios": "3.85"
          }
        }
      ],
      "brands_active": [
        "urbanCompany",
        "yammak"
      ]
    },
    {
      "is_country_live": true,
      "isd_code": "+91",
      "isd_code_int": 91,
      "phone_validation": {
        "number_length": [
          10
        ]
      },
      "country_key": "IND",
      "country_id": "IND",
      "iso_code": "IN",
      "country_name": "India",
      "distance_unit": "Km",
      "display_name": "India",
      "google_country_filter": "IN",
      "locale": "en_IN",
      "currency_code": "Rs.",
      "currency_code_symbol": "₹",
      "tz": "Asia/Kolkata",
      "country_flag": {
        "low_res": "/t_low_res_template",
        "medium_res": "/t_medium_res_template",
        "high_res": "/t_high_res_template",
        "s3_path": "/images/supply/partner-app-supply/1661338258375-6c99b1.png",
        "base_url": "https://res.cloudinary.com/urbanclap/image/upload",
        "thumb": {
          "low_res": "/t_low_res_portfolio_thumb,q_auto:low,f_auto",
          "medium_res": "/t_medium_res_portfolio_thumb,q_auto:low,f_auto",
          "high_res": "/t_high_res_portfolio_thumb,q_auto:low,f_auto"
        },
        "medium": {
          "low_res": "/t_low_res_portfolio_medium,q_auto:low,f_auto",
          "medium_res": "/t_medium_res_portfolio_medium,q_auto:low,f_auto",
          "high_res": "/t_high_res_portfolio_medium,q_auto:low,f_auto"
        }
      },
      "company_details": {
        "legal_name": "UrbanClap Technologies India Pvt. Ltd.",
        "name": "Urban Company",
        "domain_name": "www.urbancompany.com",
        "logo": ""
      },
      "customer_supported_languages": {
        "default_language": {
          "code": "en",
          "key": "english",
          "value": "English"
        },
        "supported_languages": [
          {
            "code": "en",
            "key": "english",
            "value": "English"
          }
        ]
      },
      "provider_supported_languages": {
        "default_language": {
          "code": "en",
          "key": "english",
          "value": "English"
        },
        "supported_languages": [
          {
            "code": "en",
            "key": "english",
            "value": "English"
          }
        ]
      },
      "login_sources": [
        {
          "name": "otp",
          "skip_email": false,
          "skip_name": false
        },
        {
          "name": "otp_without_email",
          "skip_email": true,
          "skip_name": true
        },
        {
          "name": "truecaller",
          "skip_email": false,
          "skip_name": false
        }
      ],
      "brands_active": [
        "urbanCompany"
      ]
    },
    {
      "is_country_live": true,
      "isd_code": "+971",
      "isd_code_int": 971,
      "phone_validation": {
        "number_length": [
          9
        ]
      },
      "country_key": "UAE",
      "country_id": "UAE",
      "iso_code": "AE",
      "country_name": "UAE",
      "distance_unit": "Km",
      "display_name": "United Arab Emirates",
      "google_country_filter": "AE",
      "locale": "en_IN",
      "currency_code": "AED",
      "currency_code_symbol": "AED",
      "tz": "Asia/Dubai",
      "country_flag": {
        "low_res": "/t_low_res_template",
        "medium_res": "/t_medium_res_template",
        "high_res": "/t_high_res_template",
        "s3_path": "/images/growth/home-screen/1661338391105-ee4996.png",
        "base_url": "https://res.cloudinary.com/urbanclap/image/upload",
        "thumb": {
          "low_res": "/t_low_res_portfolio_thumb,q_auto:low,f_auto",
          "medium_res": "/t_medium_res_portfolio_thumb,q_auto:low,f_auto",
          "high_res": "/t_high_res_portfolio_thumb,q_auto:low,f_auto"
        },
        "medium": {
          "low_res": "/t_low_res_portfolio_medium,q_auto:low,f_auto",
          "medium_res": "/t_medium_res_portfolio_medium,q_auto:low,f_auto",
          "high_res": "/t_high_res_portfolio_medium,q_auto:low,f_auto"
        }
      },
      "company_details": {
        "legal_name": "UrbanClap Technologies DMCC",
        "name": "Urban Company",
        "domain_name": "www.urbancompany.com",
        "logo": ""
      },
      "customer_supported_languages": {
        "default_language": {
          "code": "en",
          "key": "english",
          "value": "English"
        },
        "supported_languages": [
          {
            "code": "en",
            "key": "english",
            "value": "English"
          },
          {
            "code": "ar",
            "key": "arabic",
            "value": "Arabic"
          }
        ]
      },
      "provider_supported_languages": {
        "default_language": {
          "code": "en",
          "key": "english",
          "value": "English"
        },
        "supported_languages": [
          {
            "code": "en",
            "key": "english",
            "value": "English"
          },
          {
            "code": "ar",
            "key": "arabic",
            "value": "Arabic"
          }
        ]
      },
      "login_sources": [
        {
          "name": "otp",
          "skip_email": false,
          "skip_name": false
        },
        {
          "name": "otp_without_email",
          "skip_email": true,
          "skip_name": true
        },
        {
          "name": "truecaller",
          "skip_email": false,
          "skip_name": false
        },
        {
          "name": "otp_with_email",
          "skip_email": false,
          "skip_name": true,
          "min_version": {
            "android": "7.2.01",
            "ios": "3.85"
          }
        }
      ],
      "consent_context": {
        "consent_type": "Explicit",
        "allowed_modes": [
          "Sms",
          "Email"
        ],
        "mandatory_modes": [
          "Sms"
        ]
      },
      "brands_active": [
        "urbanCompany"
      ]
    },
    {
      "is_country_live": true,
      "isd_code": "+65",
      "isd_code_int": 65,
      "phone_validation": {
        "number_length": [
          8
        ]
      },
      "country_key": "SGP",
      "country_id": "SGP",
      "iso_code": "SG",
      "country_name": "Singapore",
      "distance_unit": "Km",
      "display_name": "Singapore",
      "google_country_filter": "SG",
      "locale": "en_SG",
      "currency_code": "SGD",
      "currency_code_symbol": "S$",
      "tz": "Asia/Singapore",
      "country_flag": {
        "low_res": "/t_low_res_template",
        "medium_res": "/t_medium_res_template",
        "high_res": "/t_high_res_template",
        "s3_path": "/categories/category_v2/category_03847930.png",
        "base_url": "https://res.cloudinary.com/urbanclap/image/upload",
        "thumb": {
          "low_res": "/t_low_res_portfolio_thumb,q_auto:low,f_auto",
          "medium_res": "/t_medium_res_portfolio_thumb,q_auto:low,f_auto",
          "high_res": "/t_high_res_portfolio_thumb,q_auto:low,f_auto"
        },
        "medium": {
          "low_res": "/t_low_res_portfolio_medium,q_auto:low,f_auto",
          "medium_res": "/t_medium_res_portfolio_medium,q_auto:low,f_auto",
          "high_res": "/t_high_res_portfolio_medium,q_auto:low,f_auto"
        }
      },
      "company_details": {
        "legal_name": "Urban Home Experts Pvt Ltd",
        "name": "Urban Company",
        "domain_name": "www.urbancompany.com",
        "logo": ""
      },
      "customer_supported_languages": {
        "default_language": {
          "code": "en",
          "key": "english",
          "value": "English"
        },
        "supported_languages": [
          {
            "code": "en",
            "key": "english",
            "value": "English"
          }
        ]
      },
      "provider_supported_languages": {
        "default_language": {
          "code": "en",
          "key": "english",
          "value": "English"
        },
        "supported_languages": [
          {
            "code": "en",
            "key": "english",
            "value": "English"
          }
        ]
      },
      "login_sources": [
        {
          "name": "otp",
          "skip_email": false,
          "skip_name": false
        },
        {
          "name": "otp_without_email",
          "skip_email": true,
          "skip_name": true
        },
        {
          "name": "truecaller",
          "skip_email": false,
          "skip_name": false
        },
        {
          "name": "otp_with_email",
          "skip_email": false,
          "skip_name": true,
          "min_version": {
            "android": "7.2.01",
            "ios": "3.85"
          }
        }
      ],
      "consent_context": {
        "consent_type": "ExplicitOptIn",
        "allowed_modes": [
          "Sms",
          "Email"
        ],
        "mandatory_modes": [
          "Sms"
        ]
      },
      "brands_active": [
        "urbanCompany"
      ]
    }
  ],
  "excludedGoogleIds": [
    "ChIJWzUAEOAZDTkR1wJwaxHAI4A",
    "ChIJ1XnUY9LxDDkR-Hxcc4Zexh4",
    "ChIJq4D3exr9DDkR5qdgIcEHMA0",
    "ChIJHVLRKDKEXjkRfnKeB6HNMhg",
    "ChIJ03AFdA_9DDkRuW2vyViPeAs",
    "ChIJ72ppYKZpEDkRaxAVduWJxzs",
    "ChIJLbZ-NFv9DDkRzk0gTkm3wlI",
    "ChIJL_P_CXMEDTkRw0ZdG-0GVvw",
    "ChIJSdRbuoqEXjkRFmVPYRHdzk8",
    "ChIJbU60yXAWrjsR4E9-UejD3_g",
    "ChIJa8lu5gvtDzkR_hlzUvln_6U",
    "ChIJV7ei1m6TDzkR8EAbBtdohok",
    "ChIJH_imbZDuDzkR2AjlbPGYKVE",
    "ChIJYTN9T-plUjoRM9RjaAunYW4",
    "ChIJx9Lr6tqZyzsRwvu6koO3k64",
    "ChIJgeJXTN9KbDkRCS7yDDrG4Qw",
    "ChIJZ_YISduC-DkRvCxsj-Yw40M",
    "ChIJwe1EZjDG5zsRaYxkjY_tpF0",
    "ChIJARFGZy6_wjsRQ-Oenb9DjYI",
    "ChIJWYjjgtUZDTkRHkvG5ehfzwI",
    "ChIJRcbZaklDXz4RYlEphFBu5r0",
    "ChIJufI-cg9EXj4RCBGXQZMuzMc",
    "ChIJE68fo6XA1DsRKz670AZ9sxk",
    "ChIJfVo0YnSDGjkREAbGjjQCEWg",
    "ChIJP5fmiRNDOToRaIRJlQPC2ZI",
    "ChIJq92jkavIXzkRuD9H4b_TOaw",
    "ChIJa7EyH5n9mzkR54uXCYm6zJM",
    "ChIJb8QnsXBHnDkRQXu-nyoweBc",
    "ChIJYxUdQVlO4DsRQrA4CSlYRf4",
    "ChIJ2w1BG638YjkR9EBiNdrEbgk",
    "ChIJv8a-SlENCDsRkkGEpcqC1Qs",
    "ChIJpQoX1dIJGToRqD-zaCsOWPw"
  ],
  "companyInfo": {
    "default": {
      "name": "Urban Company",
      "legal_name": "Urban Company Technologies Inc.",
      "logo": "",
      "domain_name": "www.urbancompany.com"
    },
    "KSA": {
      "legal_name": "Urban Company Arabia for Information Technology",
      "name": "Urban Company",
      "domain_name": "www.urbancompany.com",
      "logo": ""
    },
    "USA": {
      "legal_name": "Urban Company Technologies Inc.",
      "name": "Urban Company",
      "domain_name": "www.urbancompany.com",
      "logo": ""
    },
    "AUS": {
      "legal_name": "Urban Home Experts Pvt Ltd",
      "name": "Urban Company",
      "domain_name": "www.urbancompany.com",
      "logo": ""
    },
    "IND": {
      "legal_name": "UrbanClap Technologies India Pvt. Ltd.",
      "name": "Urban Company",
      "domain_name": "www.urbancompany.com",
      "logo": ""
    },
    "UAE": {
      "legal_name": "UrbanClap Technologies DMCC",
      "name": "Urban Company",
      "domain_name": "www.urbancompany.com",
      "logo": ""
    },
    "SGP": {
      "legal_name": "Urban Home Experts Pvt Ltd",
      "name": "Urban Company",
      "domain_name": "www.urbancompany.com",
      "logo": ""
    }
  },
  "brandConfig": [
    {
      "_id": "67e0fc2c8148170024c73609",
      "key": "yammak",
      "names": {
        "short": "Yammak",
        "legal": "Waed Khadmat Al-Munzal For Marketing",
        "default": "Yammak"
      },
      "logos": {
        "default": "https://images.urbanclap.com/image/upload/images/growth/home-screen/1747746283939-07c40f.jpeg",
        "short": "https://images.urbanclap.com/image/upload/images/growth/home-screen/1747870153035-6ef0d1.jpeg",
        "inverted": "https://images.urbanclap.com/image/upload/images/growth/home-screen/1747871040866-b6a1ae.jpeg",
        "shortCDN": {
          "base_url": "https://res.cloudinary.com/urbanclap/image/upload",
          "low_res": "/t_low_res_category",
          "medium_res": "/t_medium_res_category",
          "high_res": "/t_high_res_category",
          "s3_path": "/images/growth/home-screen/1747870153035-6ef0d1.jpeg"
        }
      },
      "createdAt": "2025-03-24T06:31:08.922Z",
      "updatedAt": "2025-06-19T06:58:08.973Z",
      "__v": 0,
      "common": {
        "links": {
          "termsAndConditions": "https://www.yammak.com/terms",
          "twitter": "https://x.com/Yammak_sa",
          "facebook": "https://www.facebook.com/yammak.sa",
          "instagram": "https://www.instagram.com/yammak.sa",
          "linkedin": "https://www.linkedin.com/company/yammak-sa/",
          "tiktok": "https://www.tiktok.com/@yammak.sa?_r=1&_t=ZS-91MMf2wPddY",
          "youtube": "https://www.youtube.com/@Yammak-SA"
        },
        "appsflyer": {
          "linkBrand": "m.yammak.com",
          "scheme": "yammak",
          "templateId": "RRij"
        },
        "clevertap": {
          "credentials": {
            "projectId": "8RZ-RK4-647Z",
            "projectToken": "432-12b",
            "passcode": "SOK-IWA-OAEL"
          }
        },
        "moengage": {
          "credentials": {
            "appId": "PESIHJL8F0GLVOW41MT0G4AF",
            "apiKey": "9eqhemQCVMzHiwOm1RU4y1D9"
          }
        },
        "icons": {
          "homescreenBottomTab": {
            "selected": "ic_home_filled",
            "unselected": "ic_home"
          },
          "brandNotLive": "yammak_not_live"
        },
        "assets": {
          "brandBannerWithServices": "https://res.cloudinary.com/urbanclap/image/upload/images/growth/home-screen/1753190980997-b5bd66.jpeg"
        }
      },
      "app": {
        "ios": {
          "appAssetIds": {
            "brandLogo": "yammakBrandLogo",
            "splashScreen": "JVSmascoLaunchScreen"
          },
          "appIconId": {
            "debug": "SmascoAppIconDebug",
            "release": "SmascoAppIcon"
          },
          "appName": {
            "debug": "YammakDebug",
            "release": "YammakRelease"
          },
          "appPackageId": "com.jvsmasco.customer",
          "thirdPartyTokens": {
            "crashlyticsAPIKey": "bsass121",
            "otpAutoReadHash": null
          },
          "storeLink": "https://apps.apple.com/us/app/yammak-%D9%8A%D9%85%D9%83/id6742437138"
        },
        "android": {
          "appAssetIds": {
            "brandLogo": null,
            "splashScreen": "splash"
          },
          "appIconId": {
            "debug": "ic_launcher",
            "release": "ic_launcher"
          },
          "appName": {
            "debug": "YAMMAK",
            "release": "YAMMAK"
          },
          "appPackageId": "com.urbanclap.urbanclap.yammak",
          "thirdPartyTokens": {
            "crashlyticsAPIKey": null,
            "otpAutoReadHash": "Z6mBFFzeBFz"
          },
          "storeLink": "https://play.google.com/store/apps/details?id=com.urbanclap.urbanclap.yammak"
        }
      },
      "web": {
        "domain": "www.yammak.com",
        "thirdPartyDomains": {
          "noon": "noon.yammak.com"
        }
      }
    },
    {
      "_id": "67e0fcbf7fe9a700272bf57a",
      "key": "urbanCompany",
      "names": {
        "short": "UC",
        "legal": "Urban Company Limited (formerly known as UrbanClap Technologies India Limited and UrbanClap Technologies India India Limited)",
        "default": "Urban Company"
      },
      "logos": {
        "default": "https://images.urbanclap.com/image/upload/images/supply/partner-training/1628575858610-5b0ae4.png",
        "short": "https://images.urbanclap.com/image/upload/images/growth/home-screen/1688650021762-cc2e3d.jpeg",
        "inverted": "https://images.urbanclap.com/image/upload/images/growth/home-screen/1631097450980-d2de38.png",
        "shortCDN": {
          "base_url": "https://res.cloudinary.com/urbanclap/image/upload",
          "low_res": "/t_low_res_category",
          "medium_res": "/t_medium_res_category",
          "high_res": "/t_high_res_category",
          "s3_path": "/images/growth/home-screen/1688650021762-cc2e3d.jpeg"
        }
      },
      "createdAt": "2025-03-24T06:33:35.648Z",
      "updatedAt": "2025-10-29T10:33:06.009Z",
      "__v": 0,
      "common": {
        "links": {
          "termsAndConditions": "https://www.urbancompany.com/terms",
          "twitter": "https://x.com/urbancompany_UC",
          "facebook": "https://www.facebook.com/UrbanCompany/",
          "instagram": "https://www.instagram.com/urbancompany/",
          "linkedin": "https://www.linkedin.com/company/urbancompany/mycompany/"
        },
        "appsflyer": {
          "linkBrand": "m.urbancompany.com",
          "scheme": "urbanclap",
          "templateId": "ImbW"
        },
        "clevertap": {
          "credentials": {
            "projectId": "8W4-98R-484Z",
            "projectToken": "2bc-40b",
            "passcode": "SCA-TQC-AIAL"
          }
        },
        "moengage": {
          "credentials": {
            "appId": "PESIHJL8F0GLVOW41MT0G4AF",
            "apiKey": "9eqhemQCVMzHiwOm1RU4y1D9"
          }
        },
        "icons": {
          "homescreenBottomTab": {
            "selected": "ic_hs_uc_filled",
            "unselected": "ic_hs_uc"
          },
          "brandNotLive": "uc_not_live"
        },
        "assets": {
          "brandBannerWithServices": "http://res.cloudinary.com/urbanclap/image/upload/categories/category_v2/category_8b5133c0.png"
        }
      },
      "app": {
        "ios": {
          "appAssetIds": {
            "brandLogo": "urban_company_new_logo",
            "splashScreen": "Launch Screen"
          },
          "appIconId": {
            "debug": "AppIconDebug",
            "release": "AppIcon"
          },
          "appName": {
            "debug": "Urban Company",
            "release": "Urban Company"
          },
          "appPackageId": "com.urbanclap.customer",
          "thirdPartyTokens": {
            "crashlyticsAPIKey": "asass121",
            "otpAutoReadHash": null
          },
          "storeLink": "https://apps.apple.com/US/app/id1032480595"
        },
        "android": {
          "appAssetIds": {
            "brandLogo": null,
            "splashScreen": "splash"
          },
          "appIconId": {
            "debug": "ic_launcher",
            "release": "ic_launcher"
          },
          "appName": {
            "debug": "Urban Company",
            "release": "Urban Company"
          },
          "appPackageId": "com.urbanclap.urbanclap",
          "thirdPartyTokens": {
            "crashlyticsAPIKey": null,
            "otpAutoReadHash": "gEcqWzJu2Pl"
          },
          "storeLink": "https://play.google.com/store/apps/details?id=com.urbanclap.urbanclap"
        }
      },
      "web": {
        "domain": "www.urbancompany.com",
        "thirdPartyDomains": {
          "noon": "noon.urbancompany.com",
          "mygate": "mygate.urbancompany.com"
        }
      }
    }
  ],
  "helpCenterDetails": [
    {
      "is_help_center_enabled": false,
      "is_partner_email_us_enabled": false,
      "provider_support_phone": "+966547961317",
      "customer_support_phone": "0115136102",
      "email": "help@urbancompany.com",
      "customer_support_email": "help@urbancompany.com",
      "partner_support_email": "help@urbancompany.com",
      "country_key": "KSA"
    },
    {
      "is_help_center_enabled": true,
      "is_partner_email_us_enabled": false,
      "provider_support_phone": "+911244577300",
      "customer_support_phone": "18605000020",
      "email": "help@urbancompany.com",
      "customer_support_email": "help@urbancompany.com",
      "partner_support_email": "help@urbancompany.com",
      "country_key": "IND"
    },
    {
      "is_help_center_enabled": true,
      "is_partner_email_us_enabled": true,
      "provider_support_phone": "048722302",
      "customer_support_phone": "048722301",
      "email": "help@urbanclap.com",
      "customer_support_email": "help@urbanclap.com",
      "partner_support_email": "uae-partners@urbanclap.com",
      "country_key": "UAE"
    },
    {
      "is_help_center_enabled": false,
      "is_partner_email_us_enabled": false,
      "provider_support_phone": "+6562557966",
      "customer_support_phone": "+6562557866",
      "email": "help@urbanclap.com",
      "customer_support_email": "help@urbancompany.com",
      "partner_support_email": "help@urbancompany.com",
      "country_key": "SGP"
    }
  ]
};